const e = [
  [
    {
      unicode: "😀",
      identifier: "grinning",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😃",
      identifier: "smiley",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😄",
      identifier: "smile",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😁",
      identifier: "grin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😆",
      identifier: "laughing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😅",
      identifier: "sweat_smile",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤣",
      identifier: "rolling_on_the_floor_laughing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😂",
      identifier: "joy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙂",
      identifier: "slightly_smiling_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙃",
      identifier: "upside-down_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫠",
      identifier: "melting_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😉",
      identifier: "wink",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😊",
      identifier: "blush",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😇",
      identifier: "innocent",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥰",
      identifier: "smiling_face_with_3_hearts",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😍",
      identifier: "heart_eyes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤩",
      identifier: "star-struck",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😘",
      identifier: "kissing_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😗",
      identifier: "kissing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☺️",
      identifier: "relaxed",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😚",
      identifier: "kissing_closed_eyes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😙",
      identifier: "kissing_smiling_eyes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥲",
      identifier: "smiling_face_with_tear",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😋",
      identifier: "yum",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😛",
      identifier: "stuck_out_tongue",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😜",
      identifier: "stuck_out_tongue_winking_eye",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤪",
      identifier: "zany_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😝",
      identifier: "stuck_out_tongue_closed_eyes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤑",
      identifier: "money-mouth_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤗",
      identifier: "hugging_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤭",
      identifier: "face_with_hand_over_mouth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫢",
      identifier: "face_with_open_eyes_and_hand_over_mouth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫣",
      identifier: "face_with_peeking_eye",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤫",
      identifier: "shushing_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤔",
      identifier: "thinking_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫡",
      identifier: "saluting_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤐",
      identifier: "zipper-mouth_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤨",
      identifier: "face_with_raised_eyebrow",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😐",
      identifier: "neutral_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😑",
      identifier: "expressionless",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😶",
      identifier: "no_mouth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫥",
      identifier: "dotted_line_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😶‍🌫️",
      identifier: "face_in_clouds",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😏",
      identifier: "smirk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😒",
      identifier: "unamused",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙄",
      identifier: "face_with_rolling_eyes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😬",
      identifier: "grimacing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😮‍💨",
      identifier: "face_exhaling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤥",
      identifier: "lying_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫨",
      identifier: "shaking_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙂‍↔️",
      identifier: "head_shaking_horizontally",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙂‍↕️",
      identifier: "head_shaking_vertically",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😌",
      identifier: "relieved",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😔",
      identifier: "pensive",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😪",
      identifier: "sleepy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤤",
      identifier: "drooling_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😴",
      identifier: "sleeping",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😷",
      identifier: "mask",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤒",
      identifier: "face_with_thermometer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤕",
      identifier: "face_with_head-bandage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤢",
      identifier: "nauseated_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤮",
      identifier: "face_vomiting",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤧",
      identifier: "sneezing_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥵",
      identifier: "hot_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥶",
      identifier: "cold_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥴",
      identifier: "woozy_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😵",
      identifier: "dizzy_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😵‍💫",
      identifier: "face_with_spiral_eyes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤯",
      identifier: "exploding_head",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤠",
      identifier: "face_with_cowboy_hat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥳",
      identifier: "partying_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥸",
      identifier: "disguised_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😎",
      identifier: "face_with_sunglasses",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤓",
      identifier: "nerd_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧐",
      identifier: "face_with_monocle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😕",
      identifier: "confused",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫤",
      identifier: "face_with_diagonal_mouth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😟",
      identifier: "worried",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙁",
      identifier: "slightly_frowning_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☹️",
      identifier: "white_frowning_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😮",
      identifier: "open_mouth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😯",
      identifier: "hushed",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😲",
      identifier: "astonished",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😳",
      identifier: "flushed",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥺",
      identifier: "pleading_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥹",
      identifier: "face_holding_back_tears",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😦",
      identifier: "frowning",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😧",
      identifier: "anguished",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😨",
      identifier: "fearful",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😰",
      identifier: "cold_sweat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😥",
      identifier: "disappointed_relieved",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😢",
      identifier: "cry",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😭",
      identifier: "sob",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😱",
      identifier: "scream",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😖",
      identifier: "confounded",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😣",
      identifier: "persevere",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😞",
      identifier: "disappointed",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😓",
      identifier: "sweat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😩",
      identifier: "weary",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😫",
      identifier: "tired_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥱",
      identifier: "yawning_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😤",
      identifier: "triumph",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😡",
      identifier: "rage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😠",
      identifier: "angry",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤬",
      identifier: "face_with_symbols_on_mouth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😈",
      identifier: "smiling_imp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👿",
      identifier: "imp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💀",
      identifier: "skull",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☠️",
      identifier: "skull_and_crossbones",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💩",
      identifier: "hankey",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤡",
      identifier: "clown_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👹",
      identifier: "japanese_ogre",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👺",
      identifier: "japanese_goblin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👻",
      identifier: "ghost",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👽",
      identifier: "alien",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👾",
      identifier: "space_invader",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤖",
      identifier: "robot_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😺",
      identifier: "smiley_cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😸",
      identifier: "smile_cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😹",
      identifier: "joy_cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😻",
      identifier: "heart_eyes_cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😼",
      identifier: "smirk_cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😽",
      identifier: "kissing_cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙀",
      identifier: "scream_cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😿",
      identifier: "crying_cat_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "😾",
      identifier: "pouting_cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙈",
      identifier: "see_no_evil",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙉",
      identifier: "hear_no_evil",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙊",
      identifier: "speak_no_evil",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💌",
      identifier: "love_letter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💘",
      identifier: "cupid",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💝",
      identifier: "gift_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💖",
      identifier: "sparkling_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💗",
      identifier: "heartpulse",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💓",
      identifier: "heartbeat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💞",
      identifier: "revolving_hearts",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💕",
      identifier: "two_hearts",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💟",
      identifier: "heart_decoration",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❣️",
      identifier: "heavy_heart_exclamation_mark_ornament",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💔",
      identifier: "broken_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❤️‍🔥",
      identifier: "heart_on_fire",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❤️‍🩹",
      identifier: "mending_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❤️",
      identifier: "heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩷",
      identifier: "pink_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧡",
      identifier: "orange_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💛",
      identifier: "yellow_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💚",
      identifier: "green_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💙",
      identifier: "blue_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩵",
      identifier: "light_blue_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💜",
      identifier: "purple_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤎",
      identifier: "brown_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖤",
      identifier: "black_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩶",
      identifier: "grey_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤍",
      identifier: "white_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💋",
      identifier: "kiss",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💯",
      identifier: "100",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💢",
      identifier: "anger",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💥",
      identifier: "boom",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💫",
      identifier: "dizzy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💦",
      identifier: "sweat_drops",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💨",
      identifier: "dash",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕳️",
      identifier: "hole",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💬",
      identifier: "speech_balloon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👁️‍🗨️",
      identifier: "eye-in-speech-bubble",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗨️",
      identifier: "left_speech_bubble",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗯️",
      identifier: "right_anger_bubble",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💭",
      identifier: "thought_balloon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💤",
      identifier: "zzz",
      isEmojiBase: !0,
      supportedTwemoji: null
    }
  ],
  [
    {
      unicode: "👋",
      identifier: "wave",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👋🏻",
      identifier: "wave_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👋🏼",
      identifier: "wave_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👋🏽",
      identifier: "wave_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👋🏾",
      identifier: "wave_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👋🏿",
      identifier: "wave_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤚",
      identifier: "raised_back_of_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤚🏻",
      identifier: "raised_back_of_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤚🏼",
      identifier: "raised_back_of_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤚🏽",
      identifier: "raised_back_of_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤚🏾",
      identifier: "raised_back_of_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤚🏿",
      identifier: "raised_back_of_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖐️",
      identifier: "raised_hand_with_fingers_splayed",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖐🏻",
      identifier: "raised_hand_with_fingers_splayed_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖐🏼",
      identifier: "raised_hand_with_fingers_splayed_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖐🏽",
      identifier: "raised_hand_with_fingers_splayed_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖐🏾",
      identifier: "raised_hand_with_fingers_splayed_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖐🏿",
      identifier: "raised_hand_with_fingers_splayed_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✋",
      identifier: "hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✋🏻",
      identifier: "hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✋🏼",
      identifier: "hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✋🏽",
      identifier: "hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✋🏾",
      identifier: "hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✋🏿",
      identifier: "hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖖",
      identifier: "vulcan_salute",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖖🏻",
      identifier: "spock-hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖖🏼",
      identifier: "spock-hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖖🏽",
      identifier: "spock-hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖖🏾",
      identifier: "spock-hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖖🏿",
      identifier: "spock-hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱",
      identifier: "rightwards_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏻",
      identifier: "rightwards_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏼",
      identifier: "rightwards_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏽",
      identifier: "rightwards_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏾",
      identifier: "rightwards_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏿",
      identifier: "rightwards_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫲",
      identifier: "leftwards_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫲🏻",
      identifier: "leftwards_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫲🏼",
      identifier: "leftwards_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫲🏽",
      identifier: "leftwards_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫲🏾",
      identifier: "leftwards_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫲🏿",
      identifier: "leftwards_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫳",
      identifier: "palm_down_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫳🏻",
      identifier: "palm_down_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫳🏼",
      identifier: "palm_down_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫳🏽",
      identifier: "palm_down_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫳🏾",
      identifier: "palm_down_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫳🏿",
      identifier: "palm_down_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫴",
      identifier: "palm_up_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫴🏻",
      identifier: "palm_up_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫴🏼",
      identifier: "palm_up_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫴🏽",
      identifier: "palm_up_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫴🏾",
      identifier: "palm_up_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫴🏿",
      identifier: "palm_up_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫷",
      identifier: "leftwards_pushing_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫷🏻",
      identifier: "leftwards_pushing_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫷🏼",
      identifier: "leftwards_pushing_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫷🏽",
      identifier: "leftwards_pushing_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫷🏾",
      identifier: "leftwards_pushing_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫷🏿",
      identifier: "leftwards_pushing_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫸",
      identifier: "rightwards_pushing_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫸🏻",
      identifier: "rightwards_pushing_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫸🏼",
      identifier: "rightwards_pushing_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫸🏽",
      identifier: "rightwards_pushing_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫸🏾",
      identifier: "rightwards_pushing_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫸🏿",
      identifier: "rightwards_pushing_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👌",
      identifier: "ok_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👌🏻",
      identifier: "ok_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👌🏼",
      identifier: "ok_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👌🏽",
      identifier: "ok_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👌🏾",
      identifier: "ok_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👌🏿",
      identifier: "ok_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤌",
      identifier: "pinched_fingers",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤌🏻",
      identifier: "pinched_fingers_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤌🏼",
      identifier: "pinched_fingers_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤌🏽",
      identifier: "pinched_fingers_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤌🏾",
      identifier: "pinched_fingers_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤌🏿",
      identifier: "pinched_fingers_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤏",
      identifier: "pinching_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤏🏻",
      identifier: "pinching_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤏🏼",
      identifier: "pinching_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤏🏽",
      identifier: "pinching_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤏🏾",
      identifier: "pinching_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤏🏿",
      identifier: "pinching_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✌️",
      identifier: "v",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✌🏻",
      identifier: "v_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✌🏼",
      identifier: "v_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✌🏽",
      identifier: "v_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✌🏾",
      identifier: "v_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✌🏿",
      identifier: "v_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤞",
      identifier: "crossed_fingers",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤞🏻",
      identifier: "crossed_fingers_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤞🏼",
      identifier: "crossed_fingers_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤞🏽",
      identifier: "crossed_fingers_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤞🏾",
      identifier: "crossed_fingers_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤞🏿",
      identifier: "crossed_fingers_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫰",
      identifier: "hand_with_index_finger_and_thumb_crossed",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫰🏻",
      identifier: "hand_with_index_finger_and_thumb_crossed_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫰🏼",
      identifier: "hand_with_index_finger_and_thumb_crossed_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫰🏽",
      identifier: "hand_with_index_finger_and_thumb_crossed_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫰🏾",
      identifier: "hand_with_index_finger_and_thumb_crossed_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫰🏿",
      identifier: "hand_with_index_finger_and_thumb_crossed_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤟",
      identifier: "i_love_you_hand_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤟🏻",
      identifier: "i_love_you_hand_sign_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤟🏼",
      identifier: "i_love_you_hand_sign_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤟🏽",
      identifier: "i_love_you_hand_sign_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤟🏾",
      identifier: "i_love_you_hand_sign_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤟🏿",
      identifier: "i_love_you_hand_sign_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤘",
      identifier: "sign_of_the_horns",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤘🏻",
      identifier: "the_horns_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤘🏼",
      identifier: "the_horns_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤘🏽",
      identifier: "the_horns_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤘🏾",
      identifier: "the_horns_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤘🏿",
      identifier: "the_horns_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤙",
      identifier: "call_me_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤙🏻",
      identifier: "call_me_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤙🏼",
      identifier: "call_me_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤙🏽",
      identifier: "call_me_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤙🏾",
      identifier: "call_me_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤙🏿",
      identifier: "call_me_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👈",
      identifier: "point_left",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👈🏻",
      identifier: "point_left_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👈🏼",
      identifier: "point_left_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👈🏽",
      identifier: "point_left_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👈🏾",
      identifier: "point_left_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👈🏿",
      identifier: "point_left_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👉",
      identifier: "point_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👉🏻",
      identifier: "point_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👉🏼",
      identifier: "point_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👉🏽",
      identifier: "point_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👉🏾",
      identifier: "point_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👉🏿",
      identifier: "point_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👆",
      identifier: "point_up_2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👆🏻",
      identifier: "point_up_2_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👆🏼",
      identifier: "point_up_2_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👆🏽",
      identifier: "point_up_2_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👆🏾",
      identifier: "point_up_2_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👆🏿",
      identifier: "point_up_2_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖕",
      identifier: "middle_finger",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖕🏻",
      identifier: "middle_finger_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖕🏼",
      identifier: "middle_finger_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖕🏽",
      identifier: "middle_finger_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖕🏾",
      identifier: "middle_finger_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🖕🏿",
      identifier: "middle_finger_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👇",
      identifier: "point_down",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👇🏻",
      identifier: "point_down_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👇🏼",
      identifier: "point_down_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👇🏽",
      identifier: "point_down_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👇🏾",
      identifier: "point_down_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👇🏿",
      identifier: "point_down_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "☝️",
      identifier: "point_up",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☝🏻",
      identifier: "point_up_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "☝🏼",
      identifier: "point_up_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "☝🏽",
      identifier: "point_up_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "☝🏾",
      identifier: "point_up_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "☝🏿",
      identifier: "point_up_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫵",
      identifier: "index_pointing_at_the_viewer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫵🏻",
      identifier: "index_pointing_at_the_viewer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫵🏼",
      identifier: "index_pointing_at_the_viewer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫵🏽",
      identifier: "index_pointing_at_the_viewer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫵🏾",
      identifier: "index_pointing_at_the_viewer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫵🏿",
      identifier: "index_pointing_at_the_viewer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👍",
      identifier: "thumbs_up",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👍🏻",
      identifier: "thumbs_up_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👍🏼",
      identifier: "thumbs_up_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👍🏽",
      identifier: "thumbs_up_mdeium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👍🏾",
      identifier: "thumbs_up_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👍🏿",
      identifier: "thumbs_up_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👎",
      identifier: "-1",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👎🏻",
      identifier: "-1_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👎🏼",
      identifier: "-1_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👎🏽",
      identifier: "-1_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👎🏾",
      identifier: "-1_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👎🏿",
      identifier: "-1_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✊",
      identifier: "fist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✊🏻",
      identifier: "fist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✊🏼",
      identifier: "fist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✊🏽",
      identifier: "fist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✊🏾",
      identifier: "fist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✊🏿",
      identifier: "fist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👊",
      identifier: "facepunch",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👊🏻",
      identifier: "facepunch_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👊🏼",
      identifier: "facepunch_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👊🏽",
      identifier: "facepunch_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👊🏾",
      identifier: "facepunch_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👊🏿",
      identifier: "facepunch_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤛",
      identifier: "left-facing_fist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤛🏻",
      identifier: "left-facing_fist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤛🏼",
      identifier: "left-facing_fist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤛🏽",
      identifier: "left-facing_fist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤛🏾",
      identifier: "left-facing_fist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤛🏿",
      identifier: "left-facing_fist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤜",
      identifier: "right-facing_fist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤜🏻",
      identifier: "right-facing_fist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤜🏼",
      identifier: "right-facing_fist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤜🏽",
      identifier: "right-facing_fist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤜🏾",
      identifier: "right-facing_fist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤜🏿",
      identifier: "right-facing_fist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👏",
      identifier: "clap",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👏🏻",
      identifier: "clap_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👏🏼",
      identifier: "clap_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👏🏽",
      identifier: "clap_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👏🏾",
      identifier: "clap_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👏🏿",
      identifier: "clap_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙌",
      identifier: "raised_hands",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙌🏻",
      identifier: "raised_hands_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙌🏼",
      identifier: "raised_hands_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙌🏽",
      identifier: "raised_hands_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙌🏾",
      identifier: "raised_hands_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙌🏿",
      identifier: "raised_hands_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫶",
      identifier: "heart_hands",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫶🏻",
      identifier: "heart_hands_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫶🏼",
      identifier: "heart_hands_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫶🏽",
      identifier: "heart_hands_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫶🏾",
      identifier: "heart_hands_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫶🏿",
      identifier: "heart_hands_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👐",
      identifier: "open_hands",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👐🏻",
      identifier: "open_hands_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👐🏼",
      identifier: "open_hands_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👐🏽",
      identifier: "open_hands_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👐🏾",
      identifier: "open_hands_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👐🏿",
      identifier: "open_hands_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤲",
      identifier: "palms_up_together",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤲🏻",
      identifier: "palms_up_together_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤲🏼",
      identifier: "palms_up_together_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤲🏽",
      identifier: "palms_up_together_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤲🏾",
      identifier: "palms_up_together_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤲🏿",
      identifier: "palms_up_together_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤝",
      identifier: "handshake",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤝🏻",
      identifier: "handshake_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤝🏼",
      identifier: "handshake_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤝🏽",
      identifier: "handshake_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤝🏾",
      identifier: "handshake_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤝🏿",
      identifier: "handshake_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏻‍🫲🏼",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏻‍🫲🏽",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏻‍🫲🏾",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏻‍🫲🏿",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏼‍🫲🏻",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏼‍🫲🏽",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏼‍🫲🏾",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏼‍🫲🏿",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏽‍🫲🏻",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏽‍🫲🏼",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏽‍🫲🏾",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏽‍🫲🏿",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏾‍🫲🏻",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏾‍🫲🏼",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏾‍🫲🏽",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏾‍🫲🏿",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏿‍🫲🏻",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏿‍🫲🏼",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏿‍🫲🏽",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫱🏿‍🫲🏾",
      identifier: "handshake_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙏",
      identifier: "pray",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙏🏻",
      identifier: "pray_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙏🏼",
      identifier: "pray_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙏🏽",
      identifier: "pray_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙏🏾",
      identifier: "pray_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙏🏿",
      identifier: "pray_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✍️",
      identifier: "writing_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✍🏻",
      identifier: "writing_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✍🏼",
      identifier: "writing_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✍🏽",
      identifier: "writing_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✍🏾",
      identifier: "writing_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "✍🏿",
      identifier: "writing_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💅",
      identifier: "nail_care",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💅🏻",
      identifier: "nail_care_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💅🏼",
      identifier: "nail_care_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💅🏽",
      identifier: "nail_care_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💅🏾",
      identifier: "nail_care_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💅🏿",
      identifier: "nail_care_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤳",
      identifier: "selfie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤳🏻",
      identifier: "selfie_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤳🏼",
      identifier: "selfie_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤳🏽",
      identifier: "selfie_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤳🏾",
      identifier: "selfie_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤳🏿",
      identifier: "selfie_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💪",
      identifier: "muscle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💪🏻",
      identifier: "muscle_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💪🏼",
      identifier: "muscle_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💪🏽",
      identifier: "muscle_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💪🏾",
      identifier: "muscle_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💪🏿",
      identifier: "muscle_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦾",
      identifier: "mechanical_arm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦿",
      identifier: "mechanical_leg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦵",
      identifier: "leg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦵🏻",
      identifier: "leg_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦵🏼",
      identifier: "leg_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦵🏽",
      identifier: "leg_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦵🏾",
      identifier: "leg_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦵🏿",
      identifier: "leg_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦶",
      identifier: "foot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦶🏻",
      identifier: "foot_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦶🏼",
      identifier: "foot_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦶🏽",
      identifier: "foot_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦶🏾",
      identifier: "foot_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦶🏿",
      identifier: "foot_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👂",
      identifier: "ear",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👂🏻",
      identifier: "ear_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👂🏼",
      identifier: "ear_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👂🏽",
      identifier: "ear_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👂🏾",
      identifier: "ear_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👂🏿",
      identifier: "ear_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦻",
      identifier: "ear_with_hearing_aid",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦻🏻",
      identifier: "ear_with_hearing_aid_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦻🏼",
      identifier: "ear_with_hearing_aid_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦻🏽",
      identifier: "ear_with_hearing_aid_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦻🏾",
      identifier: "ear_with_hearing_aid_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦻🏿",
      identifier: "ear_with_hearing_aid_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👃",
      identifier: "nose",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👃🏻",
      identifier: "nose_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👃🏼",
      identifier: "nose_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👃🏽",
      identifier: "nose_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👃🏾",
      identifier: "nose_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👃🏿",
      identifier: "nose_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧠",
      identifier: "brain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫀",
      identifier: "anatomical_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫁",
      identifier: "lungs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦷",
      identifier: "tooth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦴",
      identifier: "bone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👀",
      identifier: "eyes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👁️",
      identifier: "eye",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👅",
      identifier: "tongue",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👄",
      identifier: "lips",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫦",
      identifier: "biting_lip",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👶",
      identifier: "baby",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👶🏻",
      identifier: "baby_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👶🏼",
      identifier: "baby_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👶🏽",
      identifier: "baby_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👶🏾",
      identifier: "baby_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👶🏿",
      identifier: "baby_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧒",
      identifier: "child",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧒🏻",
      identifier: "child_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧒🏼",
      identifier: "child_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧒🏽",
      identifier: "child_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧒🏾",
      identifier: "child_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧒🏿",
      identifier: "child_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👦",
      identifier: "boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👦🏻",
      identifier: "boy_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👦🏼",
      identifier: "boy_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👦🏽",
      identifier: "boy_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👦🏾",
      identifier: "boy_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👦🏿",
      identifier: "boy_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👧",
      identifier: "girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👧🏻",
      identifier: "girl_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👧🏼",
      identifier: "girl_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👧🏽",
      identifier: "girl_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👧🏾",
      identifier: "girl_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👧🏿",
      identifier: "girl_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑",
      identifier: "adult",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻",
      identifier: "adult_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼",
      identifier: "adult_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽",
      identifier: "adult_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾",
      identifier: "adult_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿",
      identifier: "adult_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👱",
      identifier: "person_with_blond_hair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏻",
      identifier: "person_with_blond_hair_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏼",
      identifier: "person_with_blond_hair_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏽",
      identifier: "person_with_blond_hair_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏾",
      identifier: "person_with_blond_hair_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏿",
      identifier: "person_with_blond_hair_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨",
      identifier: "man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻",
      identifier: "man_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼",
      identifier: "man_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽",
      identifier: "man_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾",
      identifier: "man_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿",
      identifier: "man_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧔",
      identifier: "bearded_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏻",
      identifier: "bearded_person_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏼",
      identifier: "bearded_person_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏽",
      identifier: "bearded_person_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏾",
      identifier: "bearded_person_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏿",
      identifier: "bearded_person_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔‍♂️",
      identifier: "man_with_beard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏻‍♂️",
      identifier: "man_with_beard_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏼‍♂️",
      identifier: "man_with_beard_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏽‍♂️",
      identifier: "man_with_beard_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏾‍♂️",
      identifier: "man_with_beard_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏿‍♂️",
      identifier: "man_with_beard_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔‍♀️",
      identifier: "woman_with_beard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏻‍♀️",
      identifier: "woman_with_beard_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏼‍♀️",
      identifier: "woman_with_beard_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏽‍♀️",
      identifier: "woman_with_beard_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏾‍♀️",
      identifier: "woman_with_beard_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧔🏿‍♀️",
      identifier: "woman_with_beard_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦰",
      identifier: "red_haired_man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦰",
      identifier: "red_haired_man_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦰",
      identifier: "red_haired_man_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦰",
      identifier: "red_haired_man_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦰",
      identifier: "red_haired_man_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦰",
      identifier: "red_haired_man_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦱",
      identifier: "curly_haired_man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦱",
      identifier: "curly_haired_man_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦱",
      identifier: "curly_haired_man_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦱",
      identifier: "curly_haired_man_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦱",
      identifier: "curly_haired_man_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦱",
      identifier: "curly_haired_man_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦳",
      identifier: "white_haired_man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦳",
      identifier: "white_haired_man_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦳",
      identifier: "white_haired_man_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦳",
      identifier: "white_haired_man_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦳",
      identifier: "white_haired_man_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦳",
      identifier: "white_haired_man_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦲",
      identifier: "bald_man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦲",
      identifier: "bald_man_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦲",
      identifier: "bald_man_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦲",
      identifier: "bald_man_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦲",
      identifier: "bald_man_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦲",
      identifier: "bald_man_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩",
      identifier: "woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻",
      identifier: "woman_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼",
      identifier: "woman_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽",
      identifier: "woman_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾",
      identifier: "woman_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿",
      identifier: "woman_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦰",
      identifier: "red_haired_woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦰",
      identifier: "red_haired_woman_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦰",
      identifier: "red_haired_woman_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦰",
      identifier: "red_haired_woman_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦰",
      identifier: "red_haired_woman_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦰",
      identifier: "red_haired_woman_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦰",
      identifier: "red_haired_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦰",
      identifier: "red_haired_person_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦰",
      identifier: "red_haired_person_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦰",
      identifier: "red_haired_person_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦰",
      identifier: "red_haired_person_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦰",
      identifier: "red_haired_person_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦱",
      identifier: "curly_haired_woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦱",
      identifier: "curly_haired_woman_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦱",
      identifier: "curly_haired_woman_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦱",
      identifier: "curly_haired_woman_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦱",
      identifier: "curly_haired_woman_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦱",
      identifier: "curly_haired_woman_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦱",
      identifier: "curly_haired_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦱",
      identifier: "curly_haired_person_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦱",
      identifier: "curly_haired_person_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦱",
      identifier: "curly_haired_person_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦱",
      identifier: "curly_haired_person_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦱",
      identifier: "curly_haired_person_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦳",
      identifier: "white_haired_woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦳",
      identifier: "white_haired_woman_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦳",
      identifier: "white_haired_woman_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦳",
      identifier: "white_haired_woman_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦳",
      identifier: "white_haired_woman_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦳",
      identifier: "white_haired_woman_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦳",
      identifier: "white_haired_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦳",
      identifier: "white_haired_person_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦳",
      identifier: "white_haired_person_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦳",
      identifier: "white_haired_person_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦳",
      identifier: "white_haired_person_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦳",
      identifier: "white_haired_person_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦲",
      identifier: "bald_woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦲",
      identifier: "bald_woman_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦲",
      identifier: "bald_woman_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦲",
      identifier: "bald_woman_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦲",
      identifier: "bald_woman_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦲",
      identifier: "bald_woman_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦲",
      identifier: "bald_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦲",
      identifier: "bald_person_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦲",
      identifier: "bald_person_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦲",
      identifier: "bald_person_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦲",
      identifier: "bald_person_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦲",
      identifier: "bald_person_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱‍♀️",
      identifier: "blond-haired-woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏻‍♀️",
      identifier: "blond-haired-woman_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏼‍♀️",
      identifier: "blond-haired-woman_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏽‍♀️",
      identifier: "blond-haired-woman_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏾‍♀️",
      identifier: "blond-haired-woman_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏿‍♀️",
      identifier: "blond-haired-woman_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱‍♂️",
      identifier: "blond-haired-man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏻‍♂️",
      identifier: "blond-haired-man_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏼‍♂️",
      identifier: "blond-haired-man_medium_light_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏽‍♂️",
      identifier: "blond-haired-man_medium_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏾‍♂️",
      identifier: "blond-haired-man_medium_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👱🏿‍♂️",
      identifier: "blond-haired-man_dark_skin_tone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧓",
      identifier: "older_adult",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧓🏻",
      identifier: "older_adult_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧓🏼",
      identifier: "older_adult_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧓🏽",
      identifier: "older_adult_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧓🏾",
      identifier: "older_adult_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧓🏿",
      identifier: "older_adult_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👴",
      identifier: "older_man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👴🏻",
      identifier: "older_man_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👴🏼",
      identifier: "older_man_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👴🏽",
      identifier: "older_man_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👴🏾",
      identifier: "older_man_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👴🏿",
      identifier: "older_man_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👵",
      identifier: "older_woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👵🏻",
      identifier: "older_woman_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👵🏼",
      identifier: "older_woman_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👵🏽",
      identifier: "older_woman_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👵🏾",
      identifier: "older_woman_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👵🏿",
      identifier: "older_woman_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍",
      identifier: "person_frowning",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏻",
      identifier: "person_frowning_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏼",
      identifier: "person_frowning_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏽",
      identifier: "person_frowning_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏾",
      identifier: "person_frowning_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏿",
      identifier: "person_frowning_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍‍♂️",
      identifier: "man-frowning",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏻‍♂️",
      identifier: "man-frowning_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏼‍♂️",
      identifier: "man-frowning_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏽‍♂️",
      identifier: "man-frowning_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏾‍♂️",
      identifier: "man-frowning_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏿‍♂️",
      identifier: "man-frowning_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍‍♀️",
      identifier: "woman-frowning",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏻‍♀️",
      identifier: "woman-frowning_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏼‍♀️",
      identifier: "woman-frowning_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏽‍♀️",
      identifier: "woman-frowning_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏾‍♀️",
      identifier: "woman-frowning_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙍🏿‍♀️",
      identifier: "woman-frowning_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎",
      identifier: "person_with_pouting_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏻",
      identifier: "person_with_pouting_face_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏼",
      identifier: "person_with_pouting_face_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏽",
      identifier: "person_with_pouting_face_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏾",
      identifier: "person_with_pouting_face_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏿",
      identifier: "person_with_pouting_face_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎‍♂️",
      identifier: "man-pouting",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏻‍♂️",
      identifier: "man-pouting_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏼‍♂️",
      identifier: "man-pouting_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏽‍♂️",
      identifier: "man-pouting_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏾‍♂️",
      identifier: "man-pouting_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏿‍♂️",
      identifier: "man-pouting_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎‍♀️",
      identifier: "woman-pouting",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏻‍♀️",
      identifier: "woman-pouting_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏼‍♀️",
      identifier: "woman-pouting_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏽‍♀️",
      identifier: "woman-pouting_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏾‍♀️",
      identifier: "woman-pouting_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙎🏿‍♀️",
      identifier: "woman-pouting_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅",
      identifier: "no_good",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏻",
      identifier: "no_good_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏼",
      identifier: "no_good_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏽",
      identifier: "no_good_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏾",
      identifier: "no_good_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏿",
      identifier: "no_good_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅‍♂️",
      identifier: "man-gesturing-no",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏻‍♂️",
      identifier: "man-gesturing-no_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏼‍♂️",
      identifier: "man-gesturing-no_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏽‍♂️",
      identifier: "man-gesturing-no_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏾‍♂️",
      identifier: "man-gesturing-no_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏿‍♂️",
      identifier: "man-gesturing-no_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅‍♀️",
      identifier: "woman-gesturing-no",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏻‍♀️",
      identifier: "woman-gesturing-no_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏼‍♀️",
      identifier: "woman-gesturing-no_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏽‍♀️",
      identifier: "woman-gesturing-no_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏾‍♀️",
      identifier: "woman-gesturing-no_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙅🏿‍♀️",
      identifier: "woman-gesturing-no_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆",
      identifier: "ok_woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏻",
      identifier: "ok_woman_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏼",
      identifier: "ok_woman_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏽",
      identifier: "ok_woman_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏾",
      identifier: "ok_woman_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏿",
      identifier: "ok_woman_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆‍♂️",
      identifier: "man-gesturing-ok",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏻‍♂️",
      identifier: "man-gesturing-ok_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏼‍♂️",
      identifier: "man-gesturing-ok_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏽‍♂️",
      identifier: "man-gesturing-ok_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏾‍♂️",
      identifier: "man-gesturing-ok_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏿‍♂️",
      identifier: "man-gesturing-ok_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆‍♀️",
      identifier: "woman-gesturing-ok",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏻‍♀️",
      identifier: "woman-gesturing-ok_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏼‍♀️",
      identifier: "woman-gesturing-ok_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏽‍♀️",
      identifier: "woman-gesturing-ok_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏾‍♀️",
      identifier: "woman-gesturing-ok_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙆🏿‍♀️",
      identifier: "woman-gesturing-ok_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁",
      identifier: "information_desk_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏻",
      identifier: "information_desk_person_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏼",
      identifier: "information_desk_person_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏽",
      identifier: "information_desk_person_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏾",
      identifier: "information_desk_person_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏿",
      identifier: "information_desk_person_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁‍♂️",
      identifier: "man-tipping-hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏻‍♂️",
      identifier: "man-tipping-hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏼‍♂️",
      identifier: "man-tipping-hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏽‍♂️",
      identifier: "man-tipping-hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏾‍♂️",
      identifier: "man-tipping-hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏿‍♂️",
      identifier: "man-tipping-hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁‍♀️",
      identifier: "woman-tipping-hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏻‍♀️",
      identifier: "woman-tipping-hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏼‍♀️",
      identifier: "woman-tipping-hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏽‍♀️",
      identifier: "woman-tipping-hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏾‍♀️",
      identifier: "woman-tipping-hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💁🏿‍♀️",
      identifier: "woman-tipping-hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋",
      identifier: "raising_hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏻",
      identifier: "raising_hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏼",
      identifier: "raising_hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏽",
      identifier: "raising_hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏾",
      identifier: "raising_hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏿",
      identifier: "raising_hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋‍♂️",
      identifier: "man-raising-hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏻‍♂️",
      identifier: "man-raising-hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏼‍♂️",
      identifier: "man-raising-hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏽‍♂️",
      identifier: "man-raising-hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏾‍♂️",
      identifier: "man-raising-hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏿‍♂️",
      identifier: "man-raising-hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋‍♀️",
      identifier: "woman-raising-hand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏻‍♀️",
      identifier: "woman-raising-hand_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏼‍♀️",
      identifier: "woman-raising-hand_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏽‍♀️",
      identifier: "woman-raising-hand_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏾‍♀️",
      identifier: "woman-raising-hand_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙋🏿‍♀️",
      identifier: "woman-raising-hand_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏",
      identifier: "deaf_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏻",
      identifier: "deaf_person_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏼",
      identifier: "deaf_person_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏽",
      identifier: "deaf_person_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏾",
      identifier: "deaf_person_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏿",
      identifier: "deaf_person_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏‍♂️",
      identifier: "deaf_man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏻‍♂️",
      identifier: "deaf_man_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏼‍♂️",
      identifier: "deaf_man_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏽‍♂️",
      identifier: "deaf_man_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏾‍♂️",
      identifier: "deaf_man_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏿‍♂️",
      identifier: "deaf_man_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏‍♀️",
      identifier: "deaf_woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏻‍♀️",
      identifier: "deaf_woman_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏼‍♀️",
      identifier: "deaf_woman_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏽‍♀️",
      identifier: "deaf_woman_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏾‍♀️",
      identifier: "deaf_woman_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧏🏿‍♀️",
      identifier: "deaf_woman_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇",
      identifier: "bow",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏻",
      identifier: "bow_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏼",
      identifier: "bow_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏽",
      identifier: "bow_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏾",
      identifier: "bow_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏿",
      identifier: "bow_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇‍♂️",
      identifier: "man-bowing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏻‍♂️",
      identifier: "man-bowing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏼‍♂️",
      identifier: "man-bowing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏽‍♂️",
      identifier: "man-bowing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏾‍♂️",
      identifier: "man-bowing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏿‍♂️",
      identifier: "man-bowing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇‍♀️",
      identifier: "woman-bowing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏻‍♀️",
      identifier: "woman-bowing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏼‍♀️",
      identifier: "woman-bowing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏽‍♀️",
      identifier: "woman-bowing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏾‍♀️",
      identifier: "woman-bowing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🙇🏿‍♀️",
      identifier: "woman-bowing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦",
      identifier: "face_palm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏻",
      identifier: "face_palm_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏼",
      identifier: "face_palm_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏽",
      identifier: "face_palm_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏾",
      identifier: "face_palm_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏿",
      identifier: "face_palm_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦‍♂️",
      identifier: "man-facepalming",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏻‍♂️",
      identifier: "man-facepalming_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏼‍♂️",
      identifier: "man-facepalming_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏽‍♂️",
      identifier: "man-facepalming_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏾‍♂️",
      identifier: "man-facepalming_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏿‍♂️",
      identifier: "man-facepalming_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦‍♀️",
      identifier: "woman-facepalming",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏻‍♀️",
      identifier: "woman-facepalming_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏼‍♀️",
      identifier: "woman-facepalming_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏽‍♀️",
      identifier: "woman-facepalming_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏾‍♀️",
      identifier: "woman-facepalming_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤦🏿‍♀️",
      identifier: "woman-facepalming_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷",
      identifier: "shrug",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏻",
      identifier: "shrug_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏼",
      identifier: "shrug_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏽",
      identifier: "shrug_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏾",
      identifier: "shrug_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏿",
      identifier: "shrug_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷‍♂️",
      identifier: "man-shrugging",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏻‍♂️",
      identifier: "man-shrugging_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏼‍♂️",
      identifier: "man-shrugging_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏽‍♂️",
      identifier: "man-shrugging_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏾‍♂️",
      identifier: "man-shrugging_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏿‍♂️",
      identifier: "man-shrugging_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷‍♀️",
      identifier: "woman-shrugging",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏻‍♀️",
      identifier: "woman-shrugging_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏼‍♀️",
      identifier: "woman-shrugging_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏽‍♀️",
      identifier: "woman-shrugging_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏾‍♀️",
      identifier: "woman-shrugging_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤷🏿‍♀️",
      identifier: "woman-shrugging_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍⚕️",
      identifier: "health_worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍⚕️",
      identifier: "health_worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍⚕️",
      identifier: "health_worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍⚕️",
      identifier: "health_worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍⚕️",
      identifier: "health_worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍⚕️",
      identifier: "health_worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍⚕️",
      identifier: "male-doctor",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍⚕️",
      identifier: "male-doctor_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍⚕️",
      identifier: "male-doctor_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍⚕️",
      identifier: "male-doctor_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍⚕️",
      identifier: "male-doctor_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍⚕️",
      identifier: "male-doctor_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍⚕️",
      identifier: "female-doctor",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍⚕️",
      identifier: "female-doctor_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍⚕️",
      identifier: "female-doctor_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍⚕️",
      identifier: "female-doctor_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍⚕️",
      identifier: "female-doctor_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍⚕️",
      identifier: "female-doctor_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🎓",
      identifier: "student",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🎓",
      identifier: "student_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🎓",
      identifier: "student_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🎓",
      identifier: "student_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🎓",
      identifier: "student_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🎓",
      identifier: "student_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🎓",
      identifier: "male-student",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🎓",
      identifier: "male-student_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🎓",
      identifier: "male-student_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🎓",
      identifier: "male-student_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🎓",
      identifier: "male-student_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🎓",
      identifier: "male-student_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🎓",
      identifier: "female-student",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🎓",
      identifier: "female-student_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🎓",
      identifier: "female-student_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🎓",
      identifier: "female-student_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🎓",
      identifier: "female-student_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🎓",
      identifier: "female-student_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🏫",
      identifier: "teacher",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🏫",
      identifier: "teacher_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🏫",
      identifier: "teacher_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🏫",
      identifier: "teacher_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🏫",
      identifier: "teacher_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🏫",
      identifier: "teacher_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🏫",
      identifier: "male-teacher",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🏫",
      identifier: "male-teacher_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🏫",
      identifier: "male-teacher_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🏫",
      identifier: "male-teacher_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🏫",
      identifier: "male-teacher_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🏫",
      identifier: "male-teacher_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🏫",
      identifier: "female-teacher",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🏫",
      identifier: "female-teacher_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🏫",
      identifier: "female-teacher_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🏫",
      identifier: "female-teacher_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🏫",
      identifier: "female-teacher_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🏫",
      identifier: "female-teacher_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍⚖️",
      identifier: "judge",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍⚖️",
      identifier: "judge_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍⚖️",
      identifier: "judge_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍⚖️",
      identifier: "judge_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍⚖️",
      identifier: "judge_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍⚖️",
      identifier: "judge_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍⚖️",
      identifier: "male-judge",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍⚖️",
      identifier: "male-judge_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍⚖️",
      identifier: "male-judge_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍⚖️",
      identifier: "male-judge_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍⚖️",
      identifier: "male-judge_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍⚖️",
      identifier: "male-judge_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍⚖️",
      identifier: "female-judge",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍⚖️",
      identifier: "female-judge_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍⚖️",
      identifier: "female-judge_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍⚖️",
      identifier: "female-judge_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍⚖️",
      identifier: "female-judge_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍⚖️",
      identifier: "female-judge_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🌾",
      identifier: "farmer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🌾",
      identifier: "farmer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🌾",
      identifier: "farmer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🌾",
      identifier: "farmer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🌾",
      identifier: "farmer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🌾",
      identifier: "farmer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🌾",
      identifier: "male-farmer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🌾",
      identifier: "male-farmer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🌾",
      identifier: "male-farmer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🌾",
      identifier: "male-farmer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🌾",
      identifier: "male-farmer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🌾",
      identifier: "male-farmer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🌾",
      identifier: "female-farmer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🌾",
      identifier: "female-farmer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🌾",
      identifier: "female-farmer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🌾",
      identifier: "female-farmer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🌾",
      identifier: "female-farmer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🌾",
      identifier: "female-farmer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🍳",
      identifier: "cook",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🍳",
      identifier: "cook_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🍳",
      identifier: "cook_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🍳",
      identifier: "cook_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🍳",
      identifier: "cook_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🍳",
      identifier: "cook_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🍳",
      identifier: "male-cook",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🍳",
      identifier: "male-cook_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🍳",
      identifier: "male-cook_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🍳",
      identifier: "male-cook_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🍳",
      identifier: "male-cook_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🍳",
      identifier: "male-cook_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🍳",
      identifier: "female-cook",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🍳",
      identifier: "female-cook_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🍳",
      identifier: "female-cook_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🍳",
      identifier: "female-cook_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🍳",
      identifier: "female-cook_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🍳",
      identifier: "female-cook_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🔧",
      identifier: "mechanic",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🔧",
      identifier: "mechanic_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🔧",
      identifier: "mechanic_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🔧",
      identifier: "mechanic_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🔧",
      identifier: "mechanic_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🔧",
      identifier: "mechanic_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🔧",
      identifier: "male-mechanic",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🔧",
      identifier: "male-mechanic_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🔧",
      identifier: "male-mechanic_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🔧",
      identifier: "male-mechanic_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🔧",
      identifier: "male-mechanic_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🔧",
      identifier: "male-mechanic_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🔧",
      identifier: "female-mechanic",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🔧",
      identifier: "female-mechanic_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🔧",
      identifier: "female-mechanic_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🔧",
      identifier: "female-mechanic_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🔧",
      identifier: "female-mechanic_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🔧",
      identifier: "female-mechanic_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🏭",
      identifier: "factory_worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🏭",
      identifier: "factory_worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🏭",
      identifier: "factory_worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🏭",
      identifier: "factory_worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🏭",
      identifier: "factory_worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🏭",
      identifier: "factory_worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🏭",
      identifier: "male-factory-worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🏭",
      identifier: "male-factory-worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🏭",
      identifier: "male-factory-worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🏭",
      identifier: "male-factory-worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🏭",
      identifier: "male-factory-worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🏭",
      identifier: "male-factory-worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🏭",
      identifier: "female-factory-worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🏭",
      identifier: "female-factory-worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🏭",
      identifier: "female-factory-worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🏭",
      identifier: "female-factory-worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🏭",
      identifier: "female-factory-worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🏭",
      identifier: "female-factory-worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍💼",
      identifier: "office_worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍💼",
      identifier: "office_worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍💼",
      identifier: "office_worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍💼",
      identifier: "office_worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍💼",
      identifier: "office_worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍💼",
      identifier: "office_worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍💼",
      identifier: "male-office-worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍💼",
      identifier: "male-office-worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍💼",
      identifier: "male-office-worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍💼",
      identifier: "male-office-worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍💼",
      identifier: "male-office-worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍💼",
      identifier: "male-office-worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍💼",
      identifier: "female-office-worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍💼",
      identifier: "female-office-worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍💼",
      identifier: "female-office-worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍💼",
      identifier: "female-office-worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍💼",
      identifier: "female-office-worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍💼",
      identifier: "female-office-worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🔬",
      identifier: "scientist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🔬",
      identifier: "scientist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🔬",
      identifier: "scientist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🔬",
      identifier: "scientist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🔬",
      identifier: "scientist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🔬",
      identifier: "scientist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🔬",
      identifier: "male-scientist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🔬",
      identifier: "male-scientist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🔬",
      identifier: "male-scientist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🔬",
      identifier: "male-scientist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🔬",
      identifier: "male-scientist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🔬",
      identifier: "male-scientist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🔬",
      identifier: "female-scientist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🔬",
      identifier: "female-scientist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🔬",
      identifier: "female-scientist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🔬",
      identifier: "female-scientist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🔬",
      identifier: "female-scientist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🔬",
      identifier: "female-scientist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍💻",
      identifier: "technologist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍💻",
      identifier: "technologist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍💻",
      identifier: "technologist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍💻",
      identifier: "technologist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍💻",
      identifier: "technologist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍💻",
      identifier: "technologist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍💻",
      identifier: "male-technologist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍💻",
      identifier: "male-technologist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍💻",
      identifier: "male-technologist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍💻",
      identifier: "male-technologist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍💻",
      identifier: "male-technologist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍💻",
      identifier: "male-technologist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍💻",
      identifier: "female-technologist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍💻",
      identifier: "female-technologist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍💻",
      identifier: "female-technologist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍💻",
      identifier: "female-technologist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍💻",
      identifier: "female-technologist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍💻",
      identifier: "female-technologist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🎤",
      identifier: "singer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🎤",
      identifier: "singer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🎤",
      identifier: "singer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🎤",
      identifier: "singer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🎤",
      identifier: "singer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🎤",
      identifier: "singer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🎤",
      identifier: "male-singer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🎤",
      identifier: "male-singer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🎤",
      identifier: "male-singer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🎤",
      identifier: "male-singer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🎤",
      identifier: "male-singer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🎤",
      identifier: "male-singer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🎤",
      identifier: "female-singer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🎤",
      identifier: "female-singer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🎤",
      identifier: "female-singer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🎤",
      identifier: "female-singer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🎤",
      identifier: "female-singer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🎤",
      identifier: "female-singer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🎨",
      identifier: "artist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🎨",
      identifier: "artist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🎨",
      identifier: "artist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🎨",
      identifier: "artist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🎨",
      identifier: "artist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🎨",
      identifier: "artist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🎨",
      identifier: "male-artist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🎨",
      identifier: "male-artist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🎨",
      identifier: "male-artist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🎨",
      identifier: "male-artist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🎨",
      identifier: "male-artist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🎨",
      identifier: "male-artist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🎨",
      identifier: "female-artist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🎨",
      identifier: "female-artist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🎨",
      identifier: "female-artist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🎨",
      identifier: "female-artist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🎨",
      identifier: "female-artist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🎨",
      identifier: "female-artist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍✈️",
      identifier: "pilot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍✈️",
      identifier: "pilot_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍✈️",
      identifier: "pilot_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍✈️",
      identifier: "pilot_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍✈️",
      identifier: "pilot_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍✈️",
      identifier: "pilot_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍✈️",
      identifier: "male-pilot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍✈️",
      identifier: "male-pilot_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍✈️",
      identifier: "male-pilot_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍✈️",
      identifier: "male-pilot_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍✈️",
      identifier: "male-pilot_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍✈️",
      identifier: "male-pilot_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍✈️",
      identifier: "female-pilot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍✈️",
      identifier: "female-pilot_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍✈️",
      identifier: "female-pilot_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍✈️",
      identifier: "female-pilot_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍✈️",
      identifier: "female-pilot_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍✈️",
      identifier: "female-pilot_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🚀",
      identifier: "astronaut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🚀",
      identifier: "astronaut_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🚀",
      identifier: "astronaut_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🚀",
      identifier: "astronaut_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🚀",
      identifier: "astronaut_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🚀",
      identifier: "astronaut_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🚀",
      identifier: "male-astronaut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🚀",
      identifier: "male-astronaut_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🚀",
      identifier: "male-astronaut_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🚀",
      identifier: "male-astronaut_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🚀",
      identifier: "male-astronaut_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🚀",
      identifier: "male-astronaut_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🚀",
      identifier: "female-astronaut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🚀",
      identifier: "female-astronaut_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🚀",
      identifier: "female-astronaut_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🚀",
      identifier: "female-astronaut_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🚀",
      identifier: "female-astronaut_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🚀",
      identifier: "female-astronaut_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🚒",
      identifier: "firefighter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🚒",
      identifier: "firefighter_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🚒",
      identifier: "firefighter_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🚒",
      identifier: "firefighter_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🚒",
      identifier: "firefighter_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🚒",
      identifier: "firefighter_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🚒",
      identifier: "male-firefighter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🚒",
      identifier: "male-firefighter_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🚒",
      identifier: "male-firefighter_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🚒",
      identifier: "male-firefighter_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🚒",
      identifier: "male-firefighter_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🚒",
      identifier: "male-firefighter_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🚒",
      identifier: "female-firefighter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🚒",
      identifier: "female-firefighter_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🚒",
      identifier: "female-firefighter_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🚒",
      identifier: "female-firefighter_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🚒",
      identifier: "female-firefighter_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🚒",
      identifier: "female-firefighter_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮",
      identifier: "cop",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏻",
      identifier: "cop_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏼",
      identifier: "cop_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏽",
      identifier: "cop_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏾",
      identifier: "cop_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏿",
      identifier: "cop_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮‍♂️",
      identifier: "male-police-officer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏻‍♂️",
      identifier: "male-police-officer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏼‍♂️",
      identifier: "male-police-officer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏽‍♂️",
      identifier: "male-police-officer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏾‍♂️",
      identifier: "male-police-officer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏿‍♂️",
      identifier: "male-police-officer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮‍♀️",
      identifier: "female-police-officer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏻‍♀️",
      identifier: "female-police-officer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏼‍♀️",
      identifier: "female-police-officer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏽‍♀️",
      identifier: "female-police-officer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏾‍♀️",
      identifier: "female-police-officer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👮🏿‍♀️",
      identifier: "female-police-officer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵️",
      identifier: "sleuth_or_spy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏻",
      identifier: "sleuth_or_spy_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏼",
      identifier: "sleuth_or_spy_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏽",
      identifier: "sleuth_or_spy_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏾",
      identifier: "sleuth_or_spy_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏿",
      identifier: "sleuth_or_spy_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵️‍♂️",
      identifier: "male-detective",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏻‍♂️",
      identifier: "male-detective_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏼‍♂️",
      identifier: "male-detective_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏽‍♂️",
      identifier: "male-detective_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏾‍♂️",
      identifier: "male-detective_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏿‍♂️",
      identifier: "male-detective_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵️‍♀️",
      identifier: "female-detective",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏻‍♀️",
      identifier: "female-detective_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏼‍♀️",
      identifier: "female-detective_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏽‍♀️",
      identifier: "female-detective_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏾‍♀️",
      identifier: "female-detective_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕵🏿‍♀️",
      identifier: "female-detective_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂",
      identifier: "guardsman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏻",
      identifier: "guardsman_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏼",
      identifier: "guardsman_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏽",
      identifier: "guardsman_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏾",
      identifier: "guardsman_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏿",
      identifier: "guardsman_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂‍♂️",
      identifier: "male-guard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏻‍♂️",
      identifier: "male-guard_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏼‍♂️",
      identifier: "male-guard_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏽‍♂️",
      identifier: "male-guard_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏾‍♂️",
      identifier: "male-guard_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏿‍♂️",
      identifier: "male-guard_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂‍♀️",
      identifier: "female-guard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏻‍♀️",
      identifier: "female-guard_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏼‍♀️",
      identifier: "female-guard_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏽‍♀️",
      identifier: "female-guard_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏾‍♀️",
      identifier: "female-guard_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💂🏿‍♀️",
      identifier: "female-guard_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🥷",
      identifier: "ninja",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥷🏻",
      identifier: "ninja_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🥷🏼",
      identifier: "ninja_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🥷🏽",
      identifier: "ninja_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🥷🏾",
      identifier: "ninja_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🥷🏿",
      identifier: "ninja_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷",
      identifier: "construction_worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏻",
      identifier: "construction_worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏼",
      identifier: "construction_worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏽",
      identifier: "construction_worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏾",
      identifier: "construction_worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏿",
      identifier: "construction_worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷‍♂️",
      identifier: "male-construction-worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏻‍♂️",
      identifier: "male-construction-worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏼‍♂️",
      identifier: "male-construction-worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏽‍♂️",
      identifier: "male-construction-worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏾‍♂️",
      identifier: "male-construction-worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏿‍♂️",
      identifier: "male-construction-worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷‍♀️",
      identifier: "female-construction-worker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏻‍♀️",
      identifier: "female-construction-worker_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏼‍♀️",
      identifier: "female-construction-worker_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏽‍♀️",
      identifier: "female-construction-worker_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏾‍♀️",
      identifier: "female-construction-worker_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👷🏿‍♀️",
      identifier: "female-construction-worker_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫅",
      identifier: "person_with_crown",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫅🏻",
      identifier: "person_with_crown_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫅🏼",
      identifier: "person_with_crown_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫅🏽",
      identifier: "person_with_crown_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫅🏾",
      identifier: "person_with_crown_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫅🏿",
      identifier: "person_with_crown_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤴",
      identifier: "prince",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤴🏻",
      identifier: "prince_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤴🏼",
      identifier: "prince_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤴🏽",
      identifier: "prince_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤴🏾",
      identifier: "prince_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤴🏿",
      identifier: "prince_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👸",
      identifier: "princess",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👸🏻",
      identifier: "princess_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👸🏼",
      identifier: "princess_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👸🏽",
      identifier: "princess_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👸🏾",
      identifier: "princess_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👸🏿",
      identifier: "princess_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳",
      identifier: "man_with_turban",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏻",
      identifier: "man_with_turban_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏼",
      identifier: "man_with_turban_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏽",
      identifier: "man_with_turban_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏾",
      identifier: "man_with_turban_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏿",
      identifier: "man_with_turban_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳‍♂️",
      identifier: "man-wearing-turban",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏻‍♂️",
      identifier: "man-wearing-turban_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏼‍♂️",
      identifier: "man-wearing-turban_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏽‍♂️",
      identifier: "man-wearing-turban_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏾‍♂️",
      identifier: "man-wearing-turban_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏿‍♂️",
      identifier: "man-wearing-turban_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳‍♀️",
      identifier: "woman-wearing-turban",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏻‍♀️",
      identifier: "woman-wearing-turban_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏼‍♀️",
      identifier: "woman-wearing-turban_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏽‍♀️",
      identifier: "woman-wearing-turban_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏾‍♀️",
      identifier: "woman-wearing-turban_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👳🏿‍♀️",
      identifier: "woman-wearing-turban_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👲",
      identifier: "man_with_gua_pi_mao",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👲🏻",
      identifier: "man_with_gua_pi_mao_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👲🏼",
      identifier: "man_with_gua_pi_mao_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👲🏽",
      identifier: "man_with_gua_pi_mao_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👲🏾",
      identifier: "man_with_gua_pi_mao_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👲🏿",
      identifier: "man_with_gua_pi_mao_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧕",
      identifier: "person_with_headscarf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧕🏻",
      identifier: "person_with_headscarf_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧕🏼",
      identifier: "person_with_headscarf_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧕🏽",
      identifier: "person_with_headscarf_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧕🏾",
      identifier: "person_with_headscarf_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧕🏿",
      identifier: "person_with_headscarf_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵",
      identifier: "person_in_tuxedo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏻",
      identifier: "person_in_tuxedo_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏼",
      identifier: "person_in_tuxedo_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏽",
      identifier: "person_in_tuxedo_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏾",
      identifier: "person_in_tuxedo_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏿",
      identifier: "person_in_tuxedo_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵‍♂️",
      identifier: "man_in_tuxedo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏻‍♂️",
      identifier: "man_in_tuxedo_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏼‍♂️",
      identifier: "man_in_tuxedo_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏽‍♂️",
      identifier: "man_in_tuxedo_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏾‍♂️",
      identifier: "man_in_tuxedo_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏿‍♂️",
      identifier: "man_in_tuxedo_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵‍♀️",
      identifier: "woman_in_tuxedo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏻‍♀️",
      identifier: "woman_in_tuxedo_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏼‍♀️",
      identifier: "woman_in_tuxedo_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏽‍♀️",
      identifier: "woman_in_tuxedo_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏾‍♀️",
      identifier: "woman_in_tuxedo_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤵🏿‍♀️",
      identifier: "woman_in_tuxedo_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰",
      identifier: "bride_with_veil",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏻",
      identifier: "bride_with_veil_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏼",
      identifier: "bride_with_veil_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏽",
      identifier: "bride_with_veil_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏾",
      identifier: "bride_with_veil_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏿",
      identifier: "bride_with_veil_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰‍♂️",
      identifier: "man_with_veil",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏻‍♂️",
      identifier: "man_with_veil_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏼‍♂️",
      identifier: "man_with_veil_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏽‍♂️",
      identifier: "man_with_veil_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏾‍♂️",
      identifier: "man_with_veil_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏿‍♂️",
      identifier: "man_with_veil_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰‍♀️",
      identifier: "woman_with_veil",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏻‍♀️",
      identifier: "woman_with_veil_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏼‍♀️",
      identifier: "woman_with_veil_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏽‍♀️",
      identifier: "woman_with_veil_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏾‍♀️",
      identifier: "woman_with_veil_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👰🏿‍♀️",
      identifier: "woman_with_veil_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤰",
      identifier: "pregnant_woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤰🏻",
      identifier: "pregnant_woman_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤰🏼",
      identifier: "pregnant_woman_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤰🏽",
      identifier: "pregnant_woman_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤰🏾",
      identifier: "pregnant_woman_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤰🏿",
      identifier: "pregnant_woman_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫃",
      identifier: "pregnant_man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫃🏻",
      identifier: "pregnant_man_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫃🏼",
      identifier: "pregnant_man_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫃🏽",
      identifier: "pregnant_man_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫃🏾",
      identifier: "pregnant_man_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫃🏿",
      identifier: "pregnant_man_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫄",
      identifier: "pregnant_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫄🏻",
      identifier: "pregnant_person_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫄🏼",
      identifier: "pregnant_person_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫄🏽",
      identifier: "pregnant_person_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫄🏾",
      identifier: "pregnant_person_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🫄🏿",
      identifier: "pregnant_person_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤱",
      identifier: "breast-feeding",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤱🏻",
      identifier: "breast-feeding_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤱🏼",
      identifier: "breast-feeding_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤱🏽",
      identifier: "breast-feeding_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤱🏾",
      identifier: "breast-feeding_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤱🏿",
      identifier: "breast-feeding_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🍼",
      identifier: "woman_feeding_baby",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🍼",
      identifier: "woman_feeding_baby_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🍼",
      identifier: "woman_feeding_baby_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🍼",
      identifier: "woman_feeding_baby_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🍼",
      identifier: "woman_feeding_baby_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🍼",
      identifier: "woman_feeding_baby_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🍼",
      identifier: "man_feeding_baby",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🍼",
      identifier: "man_feeding_baby_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🍼",
      identifier: "man_feeding_baby_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🍼",
      identifier: "man_feeding_baby_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🍼",
      identifier: "man_feeding_baby_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🍼",
      identifier: "man_feeding_baby_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🍼",
      identifier: "person_feeding_baby",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🍼",
      identifier: "person_feeding_baby_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🍼",
      identifier: "person_feeding_baby_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🍼",
      identifier: "person_feeding_baby_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🍼",
      identifier: "person_feeding_baby_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🍼",
      identifier: "person_feeding_baby_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👼",
      identifier: "angel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👼🏻",
      identifier: "angel_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👼🏼",
      identifier: "angel_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👼🏽",
      identifier: "angel_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👼🏾",
      identifier: "angel_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👼🏿",
      identifier: "angel_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🎅",
      identifier: "santa",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎅🏻",
      identifier: "santa_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🎅🏼",
      identifier: "santa_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🎅🏽",
      identifier: "santa_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🎅🏾",
      identifier: "santa_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🎅🏿",
      identifier: "santa_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤶",
      identifier: "mrs_claus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤶🏻",
      identifier: "mrs_claus_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤶🏼",
      identifier: "mrs_claus_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤶🏽",
      identifier: "mrs_claus_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤶🏾",
      identifier: "mrs_claus_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤶🏿",
      identifier: "mrs_claus_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🎄",
      identifier: "mx_claus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🎄",
      identifier: "mx_claus_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🎄",
      identifier: "mx_claus_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🎄",
      identifier: "mx_claus_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🎄",
      identifier: "mx_claus_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🎄",
      identifier: "mx_claus_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸",
      identifier: "superhero",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏻",
      identifier: "superhero_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏼",
      identifier: "superhero_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏽",
      identifier: "superhero_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏾",
      identifier: "superhero_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏿",
      identifier: "superhero_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸‍♂️",
      identifier: "male_superhero",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏻‍♂️",
      identifier: "male_superhero_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏼‍♂️",
      identifier: "male_superhero_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏽‍♂️",
      identifier: "male_superhero_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏾‍♂️",
      identifier: "male_superhero_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏿‍♂️",
      identifier: "male_superhero_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸‍♀️",
      identifier: "female_superhero",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏻‍♀️",
      identifier: "female_superhero_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏼‍♀️",
      identifier: "female_superhero_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏽‍♀️",
      identifier: "female_superhero_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏾‍♀️",
      identifier: "female_superhero_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦸🏿‍♀️",
      identifier: "female_superhero_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹",
      identifier: "supervillain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏻",
      identifier: "supervillain_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏼",
      identifier: "supervillain_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏽",
      identifier: "supervillain_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏾",
      identifier: "supervillain_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏿",
      identifier: "supervillain_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹‍♂️",
      identifier: "male_supervillain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏻‍♂️",
      identifier: "male_supervillain_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏼‍♂️",
      identifier: "male_supervillain_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏽‍♂️",
      identifier: "male_supervillain_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏾‍♂️",
      identifier: "male_supervillain_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏿‍♂️",
      identifier: "male_supervillain_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹‍♀️",
      identifier: "female_supervillain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏻‍♀️",
      identifier: "female_supervillain_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏼‍♀️",
      identifier: "female_supervillain_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏽‍♀️",
      identifier: "female_supervillain_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏾‍♀️",
      identifier: "female_supervillain_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🦹🏿‍♀️",
      identifier: "female_supervillain_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙",
      identifier: "mage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏻",
      identifier: "mage_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏼",
      identifier: "mage_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏽",
      identifier: "mage_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏾",
      identifier: "mage_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏿",
      identifier: "mage_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙‍♂️",
      identifier: "male_mage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏻‍♂️",
      identifier: "male_mage_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏼‍♂️",
      identifier: "male_mage_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏽‍♂️",
      identifier: "male_mage_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏾‍♂️",
      identifier: "male_mage_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏿‍♂️",
      identifier: "male_mage_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙‍♀️",
      identifier: "female_mage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏻‍♀️",
      identifier: "female_mage_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏼‍♀️",
      identifier: "female_mage_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏽‍♀️",
      identifier: "female_mage_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏾‍♀️",
      identifier: "female_mage_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧙🏿‍♀️",
      identifier: "female_mage_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚",
      identifier: "fairy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏻",
      identifier: "fairy_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏼",
      identifier: "fairy_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏽",
      identifier: "fairy_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏾",
      identifier: "fairy_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏿",
      identifier: "fairy_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚‍♂️",
      identifier: "male_fairy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏻‍♂️",
      identifier: "male_fairy_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏼‍♂️",
      identifier: "male_fairy_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏽‍♂️",
      identifier: "male_fairy_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏾‍♂️",
      identifier: "male_fairy_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏿‍♂️",
      identifier: "male_fairy_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚‍♀️",
      identifier: "female_fairy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏻‍♀️",
      identifier: "female_fairy_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏼‍♀️",
      identifier: "female_fairy_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏽‍♀️",
      identifier: "female_fairy_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏾‍♀️",
      identifier: "female_fairy_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧚🏿‍♀️",
      identifier: "female_fairy_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛",
      identifier: "vampire",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏻",
      identifier: "vampire_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏼",
      identifier: "vampire_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏽",
      identifier: "vampire_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏾",
      identifier: "vampire_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏿",
      identifier: "vampire_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛‍♂️",
      identifier: "male_vampire",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏻‍♂️",
      identifier: "male_vampire_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏼‍♂️",
      identifier: "male_vampire_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏽‍♂️",
      identifier: "male_vampire_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏾‍♂️",
      identifier: "male_vampire_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏿‍♂️",
      identifier: "male_vampire_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛‍♀️",
      identifier: "female_vampire",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏻‍♀️",
      identifier: "female_vampire_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏼‍♀️",
      identifier: "female_vampire_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏽‍♀️",
      identifier: "female_vampire_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏾‍♀️",
      identifier: "female_vampire_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧛🏿‍♀️",
      identifier: "female_vampire_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜",
      identifier: "merperson",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏻",
      identifier: "merperson_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏼",
      identifier: "merperson_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏽",
      identifier: "merperson_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏾",
      identifier: "merperson_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏿",
      identifier: "merperson_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜‍♂️",
      identifier: "merman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏻‍♂️",
      identifier: "merman_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏼‍♂️",
      identifier: "merman_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏽‍♂️",
      identifier: "merman_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏾‍♂️",
      identifier: "merman_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏿‍♂️",
      identifier: "merman_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜‍♀️",
      identifier: "mermaid",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏻‍♀️",
      identifier: "mermaid_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏼‍♀️",
      identifier: "mermaid_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏽‍♀️",
      identifier: "mermaid_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏾‍♀️",
      identifier: "mermaid_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧜🏿‍♀️",
      identifier: "mermaid_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝",
      identifier: "elf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏻",
      identifier: "elf_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏼",
      identifier: "elf_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏽",
      identifier: "elf_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏾",
      identifier: "elf_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏿",
      identifier: "elf_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝‍♂️",
      identifier: "male_elf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏻‍♂️",
      identifier: "male_elf_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏼‍♂️",
      identifier: "male_elf_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏽‍♂️",
      identifier: "male_elf_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏾‍♂️",
      identifier: "male_elf_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏿‍♂️",
      identifier: "male_elf_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝‍♀️",
      identifier: "female_elf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏻‍♀️",
      identifier: "female_elf_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏼‍♀️",
      identifier: "female_elf_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏽‍♀️",
      identifier: "female_elf_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏾‍♀️",
      identifier: "female_elf_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧝🏿‍♀️",
      identifier: "female_elf_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧞",
      identifier: "genie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧞‍♂️",
      identifier: "male_genie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧞‍♀️",
      identifier: "female_genie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧟",
      identifier: "zombie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧟‍♂️",
      identifier: "male_zombie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧟‍♀️",
      identifier: "female_zombie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧌",
      identifier: "troll",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💆",
      identifier: "massage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏻",
      identifier: "massage_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏼",
      identifier: "massage_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏽",
      identifier: "massage_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏾",
      identifier: "massage_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏿",
      identifier: "massage_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆‍♂️",
      identifier: "man-getting-massage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏻‍♂️",
      identifier: "man-getting-massage_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏼‍♂️",
      identifier: "man-getting-massage_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏽‍♂️",
      identifier: "man-getting-massage_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏾‍♂️",
      identifier: "man-getting-massage_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏿‍♂️",
      identifier: "man-getting-massage_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆‍♀️",
      identifier: "woman-getting-massage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏻‍♀️",
      identifier: "woman-getting-massage_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏼‍♀️",
      identifier: "woman-getting-massage_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏽‍♀️",
      identifier: "woman-getting-massage_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏾‍♀️",
      identifier: "woman-getting-massage_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💆🏿‍♀️",
      identifier: "woman-getting-massage_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇",
      identifier: "haircut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏻",
      identifier: "haircut_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏼",
      identifier: "haircut_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏽",
      identifier: "haircut_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏾",
      identifier: "haircut_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏿",
      identifier: "haircut_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇‍♂️",
      identifier: "man-getting-haircut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏻‍♂️",
      identifier: "man-getting-haircut_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏼‍♂️",
      identifier: "man-getting-haircut_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏽‍♂️",
      identifier: "man-getting-haircut_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏾‍♂️",
      identifier: "man-getting-haircut_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏿‍♂️",
      identifier: "man-getting-haircut_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇‍♀️",
      identifier: "woman-getting-haircut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏻‍♀️",
      identifier: "woman-getting-haircut_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏼‍♀️",
      identifier: "woman-getting-haircut_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏽‍♀️",
      identifier: "woman-getting-haircut_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏾‍♀️",
      identifier: "woman-getting-haircut_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💇🏿‍♀️",
      identifier: "woman-getting-haircut_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶",
      identifier: "walking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏻",
      identifier: "walking_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏼",
      identifier: "walking_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏽",
      identifier: "walking_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏾",
      identifier: "walking_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏿",
      identifier: "walking_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶‍♂️",
      identifier: "man-walking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏻‍♂️",
      identifier: "man-walking_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏼‍♂️",
      identifier: "man-walking_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏽‍♂️",
      identifier: "man-walking_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏾‍♂️",
      identifier: "man-walking_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏿‍♂️",
      identifier: "man-walking_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶‍♀️",
      identifier: "woman-walking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏻‍♀️",
      identifier: "woman-walking_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏼‍♀️",
      identifier: "woman-walking_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏽‍♀️",
      identifier: "woman-walking_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏾‍♀️",
      identifier: "woman-walking_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏿‍♀️",
      identifier: "woman-walking_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶‍➡️",
      identifier: "person_walking_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏻‍➡️",
      identifier: "person_walking_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏼‍➡️",
      identifier: "person_walking_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏽‍➡️",
      identifier: "person_walking_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏾‍➡️",
      identifier: "person_walking_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏿‍➡️",
      identifier: "person_walking_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶‍♀️‍➡️",
      identifier: "woman_walking_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏻‍♀️‍➡️",
      identifier: "woman_walking_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏼‍♀️‍➡️",
      identifier: "woman_walking_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏽‍♀️‍➡️",
      identifier: "woman_walking_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏾‍♀️‍➡️",
      identifier: "woman_walking_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏿‍♀️‍➡️",
      identifier: "woman_walking_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶‍♂️‍➡️",
      identifier: "man_walking_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏻‍♂️‍➡️",
      identifier: "man_walking_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏼‍♂️‍➡️",
      identifier: "man_walking_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏽‍♂️‍➡️",
      identifier: "man_walking_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏾‍♂️‍➡️",
      identifier: "man_walking_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚶🏿‍♂️‍➡️",
      identifier: "man_walking_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍",
      identifier: "standing_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏻",
      identifier: "standing_person_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏼",
      identifier: "standing_person_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏽",
      identifier: "standing_person_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏾",
      identifier: "standing_person_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏿",
      identifier: "standing_person_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍‍♂️",
      identifier: "man_standing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏻‍♂️",
      identifier: "man_standing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏼‍♂️",
      identifier: "man_standing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏽‍♂️",
      identifier: "man_standing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏾‍♂️",
      identifier: "man_standing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏿‍♂️",
      identifier: "man_standing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍‍♀️",
      identifier: "woman_standing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏻‍♀️",
      identifier: "woman_standing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏼‍♀️",
      identifier: "woman_standing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏽‍♀️",
      identifier: "woman_standing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏾‍♀️",
      identifier: "woman_standing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧍🏿‍♀️",
      identifier: "woman_standing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎",
      identifier: "kneeling_person",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏻",
      identifier: "kneeling_person_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏼",
      identifier: "kneeling_person_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏽",
      identifier: "kneeling_person_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏾",
      identifier: "kneeling_person_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏿",
      identifier: "kneeling_person_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎‍♂️",
      identifier: "man_kneeling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏻‍♂️",
      identifier: "man_kneeling_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏼‍♂️",
      identifier: "man_kneeling_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏽‍♂️",
      identifier: "man_kneeling_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏾‍♂️",
      identifier: "man_kneeling_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏿‍♂️",
      identifier: "man_kneeling_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎‍♀️",
      identifier: "woman_kneeling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏻‍♀️",
      identifier: "woman_kneeling_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏼‍♀️",
      identifier: "woman_kneeling_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏽‍♀️",
      identifier: "woman_kneeling_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏾‍♀️",
      identifier: "woman_kneeling_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏿‍♀️",
      identifier: "woman_kneeling_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎‍➡️",
      identifier: "person_kneeling_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏻‍➡️",
      identifier: "person_kneeling_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏼‍➡️",
      identifier: "person_kneeling_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏽‍➡️",
      identifier: "person_kneeling_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏾‍➡️",
      identifier: "person_kneeling_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏿‍➡️",
      identifier: "person_kneeling_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎‍♀️‍➡️",
      identifier: "woman_kneeling_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏻‍♀️‍➡️",
      identifier: "woman_kneeling_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏼‍♀️‍➡️",
      identifier: "woman_kneeling_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏽‍♀️‍➡️",
      identifier: "woman_kneeling_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏾‍♀️‍➡️",
      identifier: "woman_kneeling_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏿‍♀️‍➡️",
      identifier: "woman_kneeling_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎‍♂️‍➡️",
      identifier: "man_kneeling_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏻‍♂️‍➡️",
      identifier: "man_kneeling_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏼‍♂️‍➡️",
      identifier: "man_kneeling_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏽‍♂️‍➡️",
      identifier: "man_kneeling_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏾‍♂️‍➡️",
      identifier: "man_kneeling_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧎🏿‍♂️‍➡️",
      identifier: "man_kneeling_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦯",
      identifier: "person_with_probing_cane",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦯",
      identifier: "person_with_probing_cane_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦯",
      identifier: "person_with_probing_cane_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦯",
      identifier: "person_with_probing_cane_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦯",
      identifier: "person_with_probing_cane_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦯",
      identifier: "person_with_probing_cane_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦯‍➡️",
      identifier: "person_with_white_cane_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦯‍➡️",
      identifier: "person_with_white_cane_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦯‍➡️",
      identifier: "person_with_white_cane_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦯‍➡️",
      identifier: "person_with_white_cane_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦯‍➡️",
      identifier: "person_with_white_cane_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦯‍➡️",
      identifier: "person_with_white_cane_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦯",
      identifier: "man_with_probing_cane",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦯",
      identifier: "man_with_probing_cane_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦯",
      identifier: "man_with_probing_cane_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦯",
      identifier: "man_with_probing_cane_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦯",
      identifier: "man_with_probing_cane_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦯",
      identifier: "man_with_probing_cane_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦯‍➡️",
      identifier: "man_with_white_cane_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦯‍➡️",
      identifier: "man_with_white_cane_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦯‍➡️",
      identifier: "man_with_white_cane_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦯‍➡️",
      identifier: "man_with_white_cane_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦯‍➡️",
      identifier: "man_with_white_cane_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦯‍➡️",
      identifier: "man_with_white_cane_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦯",
      identifier: "woman_with_probing_cane",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦯",
      identifier: "woman_with_probing_cane_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦯",
      identifier: "woman_with_probing_cane_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦯",
      identifier: "woman_with_probing_cane_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦯",
      identifier: "woman_with_probing_cane_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦯",
      identifier: "woman_with_probing_cane_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦯‍➡️",
      identifier: "woman_with_white_cane_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦯‍➡️",
      identifier: "woman_with_white_cane_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦯‍➡️",
      identifier: "woman_with_white_cane_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦯‍➡️",
      identifier: "woman_with_white_cane_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦯‍➡️",
      identifier: "woman_with_white_cane_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦯‍➡️",
      identifier: "woman_with_white_cane_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦼",
      identifier: "person_in_motorized_wheelchair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦼",
      identifier: "person_in_motorized_wheelchair_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦼",
      identifier: "person_in_motorized_wheelchair_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦼",
      identifier: "person_in_motorized_wheelchair_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦼",
      identifier: "person_in_motorized_wheelchair_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦼",
      identifier: "person_in_motorized_wheelchair_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦼‍➡️",
      identifier: "person_in_motorized_wheelchair_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦼‍➡️",
      identifier: "person_in_motorized_wheelchair_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦼‍➡️",
      identifier: "person_in_motorized_wheelchair_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦼‍➡️",
      identifier: "person_in_motorized_wheelchair_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦼‍➡️",
      identifier: "person_in_motorized_wheelchair_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦼‍➡️",
      identifier: "person_in_motorized_wheelchair_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦼",
      identifier: "man_in_motorized_wheelchair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦼",
      identifier: "man_in_motorized_wheelchair_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦼",
      identifier: "man_in_motorized_wheelchair_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦼",
      identifier: "man_in_motorized_wheelchair_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦼",
      identifier: "man_in_motorized_wheelchair_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦼",
      identifier: "man_in_motorized_wheelchair_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦼‍➡️",
      identifier: "man_in_motorized_wheelchair_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦼‍➡️",
      identifier: "man_in_motorized_wheelchair_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦼‍➡️",
      identifier: "man_in_motorized_wheelchair_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦼‍➡️",
      identifier: "man_in_motorized_wheelchair_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦼‍➡️",
      identifier: "man_in_motorized_wheelchair_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦼‍➡️",
      identifier: "man_in_motorized_wheelchair_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦼",
      identifier: "woman_in_motorized_wheelchair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦼",
      identifier: "woman_in_motorized_wheelchair_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦼",
      identifier: "woman_in_motorized_wheelchair_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦼",
      identifier: "woman_in_motorized_wheelchair_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦼",
      identifier: "woman_in_motorized_wheelchair_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦼",
      identifier: "woman_in_motorized_wheelchair_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦼‍➡️",
      identifier: "woman_in_motorized_wheelchair_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦼‍➡️",
      identifier: "woman_in_motorized_wheelchair_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦼‍➡️",
      identifier: "woman_in_motorized_wheelchair_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦼‍➡️",
      identifier: "woman_in_motorized_wheelchair_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦼‍➡️",
      identifier: "woman_in_motorized_wheelchair_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦼‍➡️",
      identifier: "woman_in_motorized_wheelchair_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦽",
      identifier: "person_in_manual_wheelchair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦽",
      identifier: "person_in_manual_wheelchair_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦽",
      identifier: "person_in_manual_wheelchair_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦽",
      identifier: "person_in_manual_wheelchair_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦽",
      identifier: "person_in_manual_wheelchair_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦽",
      identifier: "person_in_manual_wheelchair_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🦽‍➡️",
      identifier: "person_in_manual_wheelchair_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🦽‍➡️",
      identifier: "person_in_manual_wheelchair_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🦽‍➡️",
      identifier: "person_in_manual_wheelchair_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🦽‍➡️",
      identifier: "person_in_manual_wheelchair_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🦽‍➡️",
      identifier: "person_in_manual_wheelchair_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🦽‍➡️",
      identifier: "person_in_manual_wheelchair_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦽",
      identifier: "man_in_manual_wheelchair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦽",
      identifier: "man_in_manual_wheelchair_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦽",
      identifier: "man_in_manual_wheelchair_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦽",
      identifier: "man_in_manual_wheelchair_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦽",
      identifier: "man_in_manual_wheelchair_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦽",
      identifier: "man_in_manual_wheelchair_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍🦽‍➡️",
      identifier: "man_in_manual_wheelchair_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🦽‍➡️",
      identifier: "man_in_manual_wheelchair_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🦽‍➡️",
      identifier: "man_in_manual_wheelchair_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🦽‍➡️",
      identifier: "man_in_manual_wheelchair_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🦽‍➡️",
      identifier: "man_in_manual_wheelchair_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🦽‍➡️",
      identifier: "man_in_manual_wheelchair_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦽",
      identifier: "woman_in_manual_wheelchair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦽",
      identifier: "woman_in_manual_wheelchair_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦽",
      identifier: "woman_in_manual_wheelchair_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦽",
      identifier: "woman_in_manual_wheelchair_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦽",
      identifier: "woman_in_manual_wheelchair_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦽",
      identifier: "woman_in_manual_wheelchair_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍🦽‍➡️",
      identifier: "woman_in_manual_wheelchair_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🦽‍➡️",
      identifier: "woman_in_manual_wheelchair_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🦽‍➡️",
      identifier: "woman_in_manual_wheelchair_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🦽‍➡️",
      identifier: "woman_in_manual_wheelchair_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🦽‍➡️",
      identifier: "woman_in_manual_wheelchair_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🦽‍➡️",
      identifier: "woman_in_manual_wheelchair_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃",
      identifier: "runner",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏻",
      identifier: "runner_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏼",
      identifier: "runner_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏽",
      identifier: "runner_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏾",
      identifier: "runner_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏿",
      identifier: "runner_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃‍♂️",
      identifier: "man-running",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏻‍♂️",
      identifier: "man-running_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏼‍♂️",
      identifier: "man-running_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏽‍♂️",
      identifier: "man-running_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏾‍♂️",
      identifier: "man-running_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏿‍♂️",
      identifier: "man-running_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃‍♀️",
      identifier: "woman-running",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏻‍♀️",
      identifier: "woman-running_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏼‍♀️",
      identifier: "woman-running_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏽‍♀️",
      identifier: "woman-running_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏾‍♀️",
      identifier: "woman-running_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏿‍♀️",
      identifier: "woman-running_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃‍➡️",
      identifier: "person_running_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏻‍➡️",
      identifier: "person_running_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏼‍➡️",
      identifier: "person_running_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏽‍➡️",
      identifier: "person_running_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏾‍➡️",
      identifier: "person_running_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏿‍➡️",
      identifier: "person_running_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃‍♀️‍➡️",
      identifier: "woman_running_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏻‍♀️‍➡️",
      identifier: "woman_running_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏼‍♀️‍➡️",
      identifier: "woman_running_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏽‍♀️‍➡️",
      identifier: "woman_running_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏾‍♀️‍➡️",
      identifier: "woman_running_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏿‍♀️‍➡️",
      identifier: "woman_running_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃‍♂️‍➡️",
      identifier: "man_running_facing_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏻‍♂️‍➡️",
      identifier: "man_running_facing_right_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏼‍♂️‍➡️",
      identifier: "man_running_facing_right_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏽‍♂️‍➡️",
      identifier: "man_running_facing_right_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏾‍♂️‍➡️",
      identifier: "man_running_facing_right_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏃🏿‍♂️‍➡️",
      identifier: "man_running_facing_right_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💃",
      identifier: "dancer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💃🏻",
      identifier: "dancer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💃🏼",
      identifier: "dancer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💃🏽",
      identifier: "dancer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💃🏾",
      identifier: "dancer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💃🏿",
      identifier: "dancer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕺",
      identifier: "man_dancing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕺🏻",
      identifier: "man_dancing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕺🏼",
      identifier: "man_dancing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕺🏽",
      identifier: "man_dancing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕺🏾",
      identifier: "man_dancing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕺🏿",
      identifier: "man_dancing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕴️",
      identifier: "man_in_business_suit_levitating",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕴🏻",
      identifier: "man_in_business_suit_levitating_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕴🏼",
      identifier: "man_in_business_suit_levitating_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕴🏽",
      identifier: "man_in_business_suit_levitating_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕴🏾",
      identifier: "man_in_business_suit_levitating_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🕴🏿",
      identifier: "man_in_business_suit_levitating_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👯",
      identifier: "dancers",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👯‍♂️",
      identifier: "men-with-bunny-ears-partying",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👯‍♀️",
      identifier: "women-with-bunny-ears-partying",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧖",
      identifier: "person_in_steamy_room",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏻",
      identifier: "person_in_steamy_room_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏼",
      identifier: "person_in_steamy_room_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏽",
      identifier: "person_in_steamy_room_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏾",
      identifier: "person_in_steamy_room_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏿",
      identifier: "person_in_steamy_room_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖‍♂️",
      identifier: "man_in_steamy_room",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏻‍♂️",
      identifier: "man_in_steamy_room_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏼‍♂️",
      identifier: "man_in_steamy_room_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏽‍♂️",
      identifier: "man_in_steamy_room_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏾‍♂️",
      identifier: "man_in_steamy_room_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏿‍♂️",
      identifier: "man_in_steamy_room_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖‍♀️",
      identifier: "woman_in_steamy_room",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏻‍♀️",
      identifier: "woman_in_steamy_room_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏼‍♀️",
      identifier: "woman_in_steamy_room_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏽‍♀️",
      identifier: "woman_in_steamy_room_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏾‍♀️",
      identifier: "woman_in_steamy_room_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧖🏿‍♀️",
      identifier: "woman_in_steamy_room_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗",
      identifier: "person_climbing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏻",
      identifier: "person_climbing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏼",
      identifier: "person_climbing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏽",
      identifier: "person_climbing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏾",
      identifier: "person_climbing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏿",
      identifier: "person_climbing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗‍♂️",
      identifier: "man_climbing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏻‍♂️",
      identifier: "man_climbing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏼‍♂️",
      identifier: "man_climbing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏽‍♂️",
      identifier: "man_climbing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏾‍♂️",
      identifier: "man_climbing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏿‍♂️",
      identifier: "man_climbing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗‍♀️",
      identifier: "woman_climbing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏻‍♀️",
      identifier: "woman_climbing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏼‍♀️",
      identifier: "woman_climbing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏽‍♀️",
      identifier: "woman_climbing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏾‍♀️",
      identifier: "woman_climbing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧗🏿‍♀️",
      identifier: "woman_climbing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤺",
      identifier: "fencer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏇",
      identifier: "horse_racing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏇🏻",
      identifier: "horse_racing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏇🏼",
      identifier: "horse_racing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏇🏽",
      identifier: "horse_racing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏇🏾",
      identifier: "horse_racing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏇🏿",
      identifier: "horse_racing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛷️",
      identifier: "skier",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏂",
      identifier: "snowboarder",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏂🏻",
      identifier: "snowboarder_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏂🏼",
      identifier: "snowboarder_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏂🏽",
      identifier: "snowboarder_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏂🏾",
      identifier: "snowboarder_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏂🏿",
      identifier: "snowboarder_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌️",
      identifier: "golfer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏻",
      identifier: "golfer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏼",
      identifier: "golfer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏽",
      identifier: "golfer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏾",
      identifier: "golfer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏿",
      identifier: "golfer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌️‍♂️",
      identifier: "man-golfing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏻‍♂️",
      identifier: "man-golfing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏼‍♂️",
      identifier: "man-golfing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏽‍♂️",
      identifier: "man-golfing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏾‍♂️",
      identifier: "man-golfing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏿‍♂️",
      identifier: "man-golfing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌️‍♀️",
      identifier: "woman-golfing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏻‍♀️",
      identifier: "woman-golfing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏼‍♀️",
      identifier: "woman-golfing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏽‍♀️",
      identifier: "woman-golfing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏾‍♀️",
      identifier: "woman-golfing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏌🏿‍♀️",
      identifier: "woman-golfing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄",
      identifier: "surfer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏻",
      identifier: "surfer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏼",
      identifier: "surfer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏽",
      identifier: "surfer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏾",
      identifier: "surfer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏿",
      identifier: "surfer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄‍♂️",
      identifier: "man-surfing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏻‍♂️",
      identifier: "man-surfing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏼‍♂️",
      identifier: "man-surfing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏽‍♂️",
      identifier: "man-surfing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏾‍♂️",
      identifier: "man-surfing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏿‍♂️",
      identifier: "man-surfing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄‍♀️",
      identifier: "woman-surfing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏻‍♀️",
      identifier: "woman-surfing_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏼‍♀️",
      identifier: "woman-surfing_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏽‍♀️",
      identifier: "woman-surfing_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏾‍♀️",
      identifier: "woman-surfing_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏄🏿‍♀️",
      identifier: "woman-surfing_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣",
      identifier: "rowboat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏻",
      identifier: "rowboat_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏼",
      identifier: "rowboat_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏽",
      identifier: "rowboat_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏾",
      identifier: "rowboat_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏿",
      identifier: "rowboat_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣‍♂️",
      identifier: "man-rowing-boat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏻‍♂️",
      identifier: "man-rowing-boat_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏼‍♂️",
      identifier: "man-rowing-boat_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏽‍♂️",
      identifier: "man-rowing-boat_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏾‍♂️",
      identifier: "man-rowing-boat_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏿‍♂️",
      identifier: "man-rowing-boat_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣‍♀️",
      identifier: "woman-rowing-boat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏻‍♀️",
      identifier: "woman-rowing-boat_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏼‍♀️",
      identifier: "woman-rowing-boat_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏽‍♀️",
      identifier: "woman-rowing-boat_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏾‍♀️",
      identifier: "woman-rowing-boat_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚣🏿‍♀️",
      identifier: "woman-rowing-boat_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊",
      identifier: "swimmer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏻",
      identifier: "swimmer_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏼",
      identifier: "swimmer_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏽",
      identifier: "swimmer_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏾",
      identifier: "swimmer_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏿",
      identifier: "swimmer_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊‍♂️",
      identifier: "man-swimming",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏻‍♂️",
      identifier: "man-swimming_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏼‍♂️",
      identifier: "man-swimming_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏽‍♂️",
      identifier: "man-swimming_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏾‍♂️",
      identifier: "man-swimming_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏿‍♂️",
      identifier: "man-swimming_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊‍♀️",
      identifier: "woman-swimming",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏻‍♀️",
      identifier: "woman-swimming_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏼‍♀️",
      identifier: "woman-swimming_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏽‍♀️",
      identifier: "woman-swimming_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏾‍♀️",
      identifier: "woman-swimming_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏊🏿‍♀️",
      identifier: "woman-swimming_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹️",
      identifier: "person_with_ball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏻",
      identifier: "person_with_ball_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏼",
      identifier: "person_with_ball_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏽",
      identifier: "person_with_ball_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏾",
      identifier: "person_with_ball_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏿",
      identifier: "person_with_ball_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹️‍♂️",
      identifier: "man-bouncing-ball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏻‍♂️",
      identifier: "man-bouncing-ball_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏼‍♂️",
      identifier: "man-bouncing-ball_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏽‍♂️",
      identifier: "man-bouncing-ball_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏾‍♂️",
      identifier: "man-bouncing-ball_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏿‍♂️",
      identifier: "man-bouncing-ball_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹️‍♀️",
      identifier: "woman-bouncing-ball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏻‍♀️",
      identifier: "woman-bouncing-ball_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏼‍♀️",
      identifier: "woman-bouncing-ball_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏽‍♀️",
      identifier: "woman-bouncing-ball_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏾‍♀️",
      identifier: "woman-bouncing-ball_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "⛹🏿‍♀️",
      identifier: "woman-bouncing-ball_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋️",
      identifier: "weight_lifter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏻",
      identifier: "weight_lifter_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏼",
      identifier: "weight_lifter_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏽",
      identifier: "weight_lifter_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏾",
      identifier: "weight_lifter_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏿",
      identifier: "weight_lifter_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋️‍♂️",
      identifier: "man-lifting-weights",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏻‍♂️",
      identifier: "man-lifting-weights_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏼‍♂️",
      identifier: "man-lifting-weights_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏽‍♂️",
      identifier: "man-lifting-weights_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏾‍♂️",
      identifier: "man-lifting-weights_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏿‍♂️",
      identifier: "man-lifting-weights_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋️‍♀️",
      identifier: "woman-lifting-weights",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏻‍♀️",
      identifier: "woman-lifting-weights_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏼‍♀️",
      identifier: "woman-lifting-weights_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏽‍♀️",
      identifier: "woman-lifting-weights_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏾‍♀️",
      identifier: "woman-lifting-weights_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏋🏿‍♀️",
      identifier: "woman-lifting-weights_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴",
      identifier: "bicyclist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏻",
      identifier: "bicyclist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏼",
      identifier: "bicyclist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏽",
      identifier: "bicyclist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏾",
      identifier: "bicyclist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏿",
      identifier: "bicyclist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴‍♂️",
      identifier: "man-biking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏻‍♂️",
      identifier: "man-biking_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏼‍♂️",
      identifier: "man-biking_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏽‍♂️",
      identifier: "man-biking_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏾‍♂️",
      identifier: "man-biking_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏿‍♂️",
      identifier: "man-biking_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴‍♀️",
      identifier: "woman-biking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏻‍♀️",
      identifier: "woman-biking_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏼‍♀️",
      identifier: "woman-biking_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏽‍♀️",
      identifier: "woman-biking_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏾‍♀️",
      identifier: "woman-biking_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚴🏿‍♀️",
      identifier: "woman-biking_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵",
      identifier: "mountain_bicyclist",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏻",
      identifier: "mountain_bicyclist_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏼",
      identifier: "mountain_bicyclist_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏽",
      identifier: "mountain_bicyclist_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏾",
      identifier: "mountain_bicyclist_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏿",
      identifier: "mountain_bicyclist_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵‍♂️",
      identifier: "man-mountain-biking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏻‍♂️",
      identifier: "man-mountain-biking_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏼‍♂️",
      identifier: "man-mountain-biking_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏽‍♂️",
      identifier: "man-mountain-biking_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏾‍♂️",
      identifier: "man-mountain-biking_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏿‍♂️",
      identifier: "man-mountain-biking_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵‍♀️",
      identifier: "woman-mountain-biking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏻‍♀️",
      identifier: "woman-mountain-biking_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏼‍♀️",
      identifier: "woman-mountain-biking_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏽‍♀️",
      identifier: "woman-mountain-biking_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏾‍♀️",
      identifier: "woman-mountain-biking_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🚵🏿‍♀️",
      identifier: "woman-mountain-biking_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸",
      identifier: "person_doing_cartwheel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏻",
      identifier: "person_doing_cartwheel_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏼",
      identifier: "person_doing_cartwheel_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏽",
      identifier: "person_doing_cartwheel_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏾",
      identifier: "person_doing_cartwheel_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏿",
      identifier: "person_doing_cartwheel_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸‍♂️",
      identifier: "man-cartwheeling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏻‍♂️",
      identifier: "man-cartwheeling_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏼‍♂️",
      identifier: "man-cartwheeling_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏽‍♂️",
      identifier: "man-cartwheeling_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏾‍♂️",
      identifier: "man-cartwheeling_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏿‍♂️",
      identifier: "man-cartwheeling_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸‍♀️",
      identifier: "woman-cartwheeling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏻‍♀️",
      identifier: "woman-cartwheeling_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏼‍♀️",
      identifier: "woman-cartwheeling_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏽‍♀️",
      identifier: "woman-cartwheeling_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏾‍♀️",
      identifier: "woman-cartwheeling_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤸🏿‍♀️",
      identifier: "woman-cartwheeling_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤼",
      identifier: "wrestlers",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤼‍♂️",
      identifier: "man-wrestling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤼‍♀️",
      identifier: "woman-wrestling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤽",
      identifier: "water_polo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏻",
      identifier: "water_polo_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏼",
      identifier: "water_polo_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏽",
      identifier: "water_polo_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏾",
      identifier: "water_polo_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏿",
      identifier: "water_polo_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽‍♂️",
      identifier: "man-playing-water-polo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏻‍♂️",
      identifier: "man-playing-water-polo_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏼‍♂️",
      identifier: "man-playing-water-polo_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏽‍♂️",
      identifier: "man-playing-water-polo_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏾‍♂️",
      identifier: "man-playing-water-polo_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏿‍♂️",
      identifier: "man-playing-water-polo_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽‍♀️",
      identifier: "woman-playing-water-polo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏻‍♀️",
      identifier: "woman-playing-water-polo_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏼‍♀️",
      identifier: "woman-playing-water-polo_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏽‍♀️",
      identifier: "woman-playing-water-polo_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏾‍♀️",
      identifier: "woman-playing-water-polo_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤽🏿‍♀️",
      identifier: "woman-playing-water-polo_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾",
      identifier: "handball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏻",
      identifier: "handball_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏼",
      identifier: "handball_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏽",
      identifier: "handball_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏾",
      identifier: "handball_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏿",
      identifier: "handball_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾‍♂️",
      identifier: "man-playing-handball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏻‍♂️",
      identifier: "man-playing-handball_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏼‍♂️",
      identifier: "man-playing-handball_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏽‍♂️",
      identifier: "man-playing-handball_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏾‍♂️",
      identifier: "man-playing-handball_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏿‍♂️",
      identifier: "man-playing-handball_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾‍♀️",
      identifier: "woman-playing-handball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏻‍♀️",
      identifier: "woman-playing-handball_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏼‍♀️",
      identifier: "woman-playing-handball_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏽‍♀️",
      identifier: "woman-playing-handball_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏾‍♀️",
      identifier: "woman-playing-handball_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤾🏿‍♀️",
      identifier: "woman-playing-handball_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹",
      identifier: "juggling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏻",
      identifier: "juggling_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏼",
      identifier: "juggling_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏽",
      identifier: "juggling_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏾",
      identifier: "juggling_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏿",
      identifier: "juggling_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹‍♂️",
      identifier: "man-juggling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏻‍♂️",
      identifier: "man-juggling_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏼‍♂️",
      identifier: "man-juggling_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏽‍♂️",
      identifier: "man-juggling_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏾‍♂️",
      identifier: "man-juggling_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏿‍♂️",
      identifier: "man-juggling_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹‍♀️",
      identifier: "woman-juggling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏻‍♀️",
      identifier: "woman-juggling_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏼‍♀️",
      identifier: "woman-juggling_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏽‍♀️",
      identifier: "woman-juggling_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏾‍♀️",
      identifier: "woman-juggling_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🤹🏿‍♀️",
      identifier: "woman-juggling_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘",
      identifier: "person_in_lotus_position",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏻",
      identifier: "person_in_lotus_position_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏼",
      identifier: "person_in_lotus_position_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏽",
      identifier: "person_in_lotus_position_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏾",
      identifier: "person_in_lotus_position_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏿",
      identifier: "person_in_lotus_position_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘‍♂️",
      identifier: "man_in_lotus_position",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏻‍♂️",
      identifier: "man_in_lotus_position_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏼‍♂️",
      identifier: "man_in_lotus_position_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏽‍♂️",
      identifier: "man_in_lotus_position_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏾‍♂️",
      identifier: "man_in_lotus_position_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏿‍♂️",
      identifier: "man_in_lotus_position_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘‍♀️",
      identifier: "woman_in_lotus_position",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏻‍♀️",
      identifier: "woman_in_lotus_position_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏼‍♀️",
      identifier: "woman_in_lotus_position_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏽‍♀️",
      identifier: "woman_in_lotus_position_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏾‍♀️",
      identifier: "woman_in_lotus_position_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧘🏿‍♀️",
      identifier: "woman_in_lotus_position_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛀",
      identifier: "bath",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛀🏻",
      identifier: "bath_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛀🏼",
      identifier: "bath_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛀🏽",
      identifier: "bath_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛀🏾",
      identifier: "bath_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛀🏿",
      identifier: "bath_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛌",
      identifier: "person_in_bed",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛌🏻",
      identifier: "sleeping_accommodation_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛌🏼",
      identifier: "sleeping_accommodation_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛌🏽",
      identifier: "sleeping_accommodation_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛌🏾",
      identifier: "sleeping_accommodation_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🛌🏿",
      identifier: "sleeping_accommodation_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🤝‍🧑",
      identifier: "people_holding_hands",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🤝‍🧑🏻",
      identifier: "people_holding_hands_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🤝‍🧑🏼",
      identifier: "people_holding_hands_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🤝‍🧑🏽",
      identifier: "people_holding_hands_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🤝‍🧑🏾",
      identifier: "people_holding_hands_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍🤝‍🧑🏿",
      identifier: "people_holding_hands_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🤝‍🧑🏻",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🤝‍🧑🏼",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🤝‍🧑🏽",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🤝‍🧑🏾",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍🤝‍🧑🏿",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🤝‍🧑🏻",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🤝‍🧑🏼",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🤝‍🧑🏽",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🤝‍🧑🏾",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍🤝‍🧑🏿",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🤝‍🧑🏻",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🤝‍🧑🏼",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🤝‍🧑🏽",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🤝‍🧑🏾",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍🤝‍🧑🏿",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🤝‍🧑🏻",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🤝‍🧑🏼",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🤝‍🧑🏽",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🤝‍🧑🏾",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍🤝‍🧑🏿",
      identifier: "people_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👭",
      identifier: "two_women_holding_hands",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👭🏻",
      identifier: "two_women_holding_hands_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🤝‍👩🏼",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🤝‍👩🏽",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🤝‍👩🏾",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🤝‍👩🏿",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🤝‍👩🏻",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👭🏼",
      identifier: "two_women_holding_hands_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🤝‍👩🏽",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🤝‍👩🏾",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🤝‍👩🏿",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🤝‍👩🏻",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🤝‍👩🏼",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👭🏽",
      identifier: "two_women_holding_hands_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🤝‍👩🏾",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🤝‍👩🏿",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🤝‍👩🏻",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🤝‍👩🏼",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🤝‍👩🏽",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👭🏾",
      identifier: "two_women_holding_hands_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🤝‍👩🏿",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🤝‍👩🏻",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🤝‍👩🏼",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🤝‍👩🏽",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🤝‍👩🏾",
      identifier: "two_women_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👭🏿",
      identifier: "two_women_holding_hands_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👫",
      identifier: "man_and_woman_holding_hands",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👫🏻",
      identifier: "man_and_woman_holding_hands_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🤝‍👨🏼",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🤝‍👨🏽",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🤝‍👨🏾",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍🤝‍👨🏿",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🤝‍👨🏻",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👫🏼",
      identifier: "man_and_woman_holding_hands_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🤝‍👨🏽",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🤝‍👨🏾",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍🤝‍👨🏿",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🤝‍👨🏻",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🤝‍👨🏼",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👫🏽",
      identifier: "man_and_woman_holding_hands_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🤝‍👨🏾",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍🤝‍👨🏿",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🤝‍👨🏻",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🤝‍👨🏼",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🤝‍👨🏽",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👫🏾",
      identifier: "man_and_woman_holding_hands_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍🤝‍👨🏿",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🤝‍👨🏻",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🤝‍👨🏼",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🤝‍👨🏽",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍🤝‍👨🏾",
      identifier: "man_and_woman_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👫🏿",
      identifier: "man_and_woman_holding_hands_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👬",
      identifier: "two_men_holding_hands",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👬🏻",
      identifier: "two_men_holding_hands_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🤝‍👨🏼",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🤝‍👨🏽",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🤝‍👨🏾",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍🤝‍👨🏿",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🤝‍👨🏻",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👬🏼",
      identifier: "two_men_holding_hands_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🤝‍👨🏽",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🤝‍👨🏾",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍🤝‍👨🏿",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🤝‍👨🏻",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🤝‍👨🏼",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👬🏽",
      identifier: "two_men_holding_hands_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🤝‍👨🏾",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍🤝‍👨🏿",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🤝‍👨🏻",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🤝‍👨🏼",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🤝‍👨🏽",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👬🏾",
      identifier: "two_men_holding_hands_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍🤝‍👨🏿",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🤝‍👨🏻",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🤝‍👨🏼",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🤝‍👨🏽",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍🤝‍👨🏾",
      identifier: "two_men_holding_hands_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👬🏿",
      identifier: "two_men_holding_hands_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💏",
      identifier: "couplekiss",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💏🏻",
      identifier: "couplekiss_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💏🏼",
      identifier: "couplekiss_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💏🏽",
      identifier: "couplekiss_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💏🏾",
      identifier: "couplekiss_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💏🏿",
      identifier: "couplekiss_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍❤️‍💋‍🧑🏼",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍❤️‍💋‍🧑🏽",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍❤️‍💋‍🧑🏾",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍❤️‍💋‍🧑🏿",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍❤️‍💋‍🧑🏻",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍❤️‍💋‍🧑🏽",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍❤️‍💋‍🧑🏾",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍❤️‍💋‍🧑🏿",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍❤️‍💋‍🧑🏻",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍❤️‍💋‍🧑🏼",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍❤️‍💋‍🧑🏾",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍❤️‍💋‍🧑🏿",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍❤️‍💋‍🧑🏻",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍❤️‍💋‍🧑🏼",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍❤️‍💋‍🧑🏽",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍❤️‍💋‍🧑🏿",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍❤️‍💋‍🧑🏻",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍❤️‍💋‍🧑🏼",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍❤️‍💋‍🧑🏽",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍❤️‍💋‍🧑🏾",
      identifier: "couplekiss_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍❤️‍💋‍👨",
      identifier: "woman-kiss-man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👨🏻",
      identifier: "woman-kiss-man_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👨🏼",
      identifier: "woman-kiss-man_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👨🏽",
      identifier: "woman-kiss-man_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👨🏾",
      identifier: "woman-kiss-man_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👨🏿",
      identifier: "woman-kiss-man_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👨🏻",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👨🏼",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👨🏽",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👨🏾",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👨🏿",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👨🏻",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👨🏼",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👨🏽",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👨🏾",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👨🏿",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👨🏻",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👨🏼",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👨🏽",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👨🏾",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👨🏿",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👨🏻",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👨🏼",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👨🏽",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👨🏾",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👨🏿",
      identifier: "woman-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍❤️‍💋‍👨",
      identifier: "man-kiss-man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍💋‍👨🏻",
      identifier: "man-kiss-man_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍💋‍👨🏼",
      identifier: "man-kiss-man_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍💋‍👨🏽",
      identifier: "man-kiss-man_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍💋‍👨🏾",
      identifier: "man-kiss-man_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍💋‍👨🏿",
      identifier: "man-kiss-man_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍💋‍👨🏻",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍💋‍👨🏼",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍💋‍👨🏽",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍💋‍👨🏾",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍💋‍👨🏿",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍💋‍👨🏻",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍💋‍👨🏼",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍💋‍👨🏽",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍💋‍👨🏾",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍💋‍👨🏿",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍💋‍👨🏻",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍💋‍👨🏼",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍💋‍👨🏽",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍💋‍👨🏾",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍💋‍👨🏿",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍💋‍👨🏻",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍💋‍👨🏼",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍💋‍👨🏽",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍💋‍👨🏾",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍💋‍👨🏿",
      identifier: "man-kiss-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍❤️‍💋‍👩",
      identifier: "woman-kiss-woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👩🏻",
      identifier: "woman-kiss-woman_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👩🏼",
      identifier: "woman-kiss-woman_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👩🏽",
      identifier: "woman-kiss-woman_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👩🏾",
      identifier: "woman-kiss-woman_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍💋‍👩🏿",
      identifier: "woman-kiss-woman_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👩🏻",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👩🏼",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👩🏽",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👩🏾",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍💋‍👩🏿",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👩🏻",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👩🏼",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👩🏽",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👩🏾",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍💋‍👩🏿",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👩🏻",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👩🏼",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👩🏽",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👩🏾",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍💋‍👩🏿",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👩🏻",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👩🏼",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👩🏽",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👩🏾",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍💋‍👩🏿",
      identifier: "woman-kiss-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💑",
      identifier: "couple_with_heart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💑🏻",
      identifier: "couple_with_heart_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💑🏼",
      identifier: "couple_with_heart_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💑🏽",
      identifier: "couple_with_heart_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💑🏾",
      identifier: "couple_with_heart_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "💑🏿",
      identifier: "couple_with_heart_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍❤️‍🧑🏼",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍❤️‍🧑🏽",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍❤️‍🧑🏾",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏻‍❤️‍🧑🏿",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍❤️‍🧑🏻",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍❤️‍🧑🏽",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍❤️‍🧑🏾",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏼‍❤️‍🧑🏿",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍❤️‍🧑🏻",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍❤️‍🧑🏼",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍❤️‍🧑🏾",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏽‍❤️‍🧑🏿",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍❤️‍🧑🏻",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍❤️‍🧑🏼",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍❤️‍🧑🏽",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏾‍❤️‍🧑🏿",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍❤️‍🧑🏻",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍❤️‍🧑🏼",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍❤️‍🧑🏽",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🧑🏿‍❤️‍🧑🏾",
      identifier: "couple_with_heart_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍❤️‍👨",
      identifier: "woman-heart-man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👨🏻",
      identifier: "woman-heart-man_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👨🏼",
      identifier: "woman-heart-man_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👨🏽",
      identifier: "woman-heart-man_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👨🏾",
      identifier: "woman-heart-man_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👨🏿",
      identifier: "woman-heart-man_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👨🏻",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👨🏼",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👨🏽",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👨🏾",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👨🏿",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👨🏻",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👨🏼",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👨🏽",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👨🏾",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👨🏿",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👨🏻",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👨🏼",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👨🏽",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👨🏾",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👨🏿",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👨🏻",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👨🏼",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👨🏽",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👨🏾",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👨🏿",
      identifier: "woman-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍❤️‍👨",
      identifier: "man-heart-man",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍👨🏻",
      identifier: "man-heart-man_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍👨🏼",
      identifier: "man-heart-man_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍👨🏽",
      identifier: "man-heart-man_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍👨🏾",
      identifier: "man-heart-man_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏻‍❤️‍👨🏿",
      identifier: "man-heart-man_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍👨🏻",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍👨🏼",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍👨🏽",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍👨🏾",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏼‍❤️‍👨🏿",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍👨🏻",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍👨🏼",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍👨🏽",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍👨🏾",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏽‍❤️‍👨🏿",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍👨🏻",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍👨🏼",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍👨🏽",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍👨🏾",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏾‍❤️‍👨🏿",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍👨🏻",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍👨🏼",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍👨🏽",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍👨🏾",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨🏿‍❤️‍👨🏿",
      identifier: "man-heart-man_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍❤️‍👩",
      identifier: "woman-heart-woman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👩🏻",
      identifier: "woman-heart-woman_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👩🏼",
      identifier: "woman-heart-woman_medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👩🏽",
      identifier: "woman-heart-woman_medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👩🏾",
      identifier: "woman-heart-woman_medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏻‍❤️‍👩🏿",
      identifier: "woman-heart-woman_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👩🏻",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👩🏼",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👩🏽",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👩🏾",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏼‍❤️‍👩🏿",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👩🏻",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👩🏼",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👩🏽",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👩🏾",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏽‍❤️‍👩🏿",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👩🏻",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👩🏼",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👩🏽",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👩🏾",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏾‍❤️‍👩🏿",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👩🏻",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👩🏼",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👩🏽",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👩🏾",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👩🏿‍❤️‍👩🏿",
      identifier: "woman-heart-woman_undefined",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👩‍👦",
      identifier: "man-woman-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👩‍👧",
      identifier: "man-woman-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👩‍👧‍👦",
      identifier: "man-woman-girl-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👩‍👦‍👦",
      identifier: "man-woman-boy-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👩‍👧‍👧",
      identifier: "man-woman-girl-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👨‍👦",
      identifier: "man-man-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👨‍👧",
      identifier: "man-man-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👨‍👧‍👦",
      identifier: "man-man-girl-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👨‍👦‍👦",
      identifier: "man-man-boy-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👨‍👧‍👧",
      identifier: "man-man-girl-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👩‍👦",
      identifier: "woman-woman-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👩‍👧",
      identifier: "woman-woman-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👩‍👧‍👦",
      identifier: "woman-woman-girl-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👩‍👦‍👦",
      identifier: "woman-woman-boy-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👩‍👧‍👧",
      identifier: "woman-woman-girl-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👦",
      identifier: "man-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👦‍👦",
      identifier: "man-boy-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👧",
      identifier: "man-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👧‍👦",
      identifier: "man-girl-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👨‍👧‍👧",
      identifier: "man-girl-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👦",
      identifier: "woman-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👦‍👦",
      identifier: "woman-boy-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👧",
      identifier: "woman-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👧‍👦",
      identifier: "woman-girl-boy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👩‍👧‍👧",
      identifier: "woman-girl-girl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗣️",
      identifier: "speaking_head_in_silhouette",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👤",
      identifier: "bust_in_silhouette",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👥",
      identifier: "busts_in_silhouette",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫂",
      identifier: "people_hugging",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👪",
      identifier: "family",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🧑‍🧒",
      identifier: "family_adult_adult_child",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🧑‍🧒‍🧒",
      identifier: "family_adult_adult_child_child",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🧒",
      identifier: "family_adult_child",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧑‍🧒‍🧒",
      identifier: "family_adult_child_child",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👣",
      identifier: "footprints",
      isEmojiBase: !0,
      supportedTwemoji: null
    }
  ],
  [],
  [
    {
      unicode: "🐵",
      identifier: "monkey_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐒",
      identifier: "monkey",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦍",
      identifier: "gorilla",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦧",
      identifier: "orangutan",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐶",
      identifier: "dog",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐕",
      identifier: "dog2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦮",
      identifier: "guide_dog",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐕‍🦺",
      identifier: "service_dog",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐩",
      identifier: "poodle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐺",
      identifier: "wolf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦊",
      identifier: "fox_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦝",
      identifier: "raccoon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐱",
      identifier: "cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐈",
      identifier: "cat2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐈‍⬛",
      identifier: "black_cat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦁",
      identifier: "lion_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐯",
      identifier: "tiger",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐅",
      identifier: "tiger2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐆",
      identifier: "leopard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐴",
      identifier: "horse",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫎",
      identifier: "moose",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫏",
      identifier: "donkey",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐎",
      identifier: "racehorse",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦄",
      identifier: "unicorn_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦓",
      identifier: "zebra_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦌",
      identifier: "deer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦬",
      identifier: "bison",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐮",
      identifier: "cow",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐂",
      identifier: "ox",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐃",
      identifier: "water_buffalo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐄",
      identifier: "cow2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐷",
      identifier: "pig",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐖",
      identifier: "pig2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐗",
      identifier: "boar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐽",
      identifier: "pig_nose",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐏",
      identifier: "ram",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐑",
      identifier: "sheep",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐐",
      identifier: "goat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐪",
      identifier: "dromedary_camel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐫",
      identifier: "camel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦙",
      identifier: "llama",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦒",
      identifier: "giraffe_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐘",
      identifier: "elephant",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦣",
      identifier: "mammoth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦏",
      identifier: "rhinoceros",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦛",
      identifier: "hippopotamus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐭",
      identifier: "mouse",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐁",
      identifier: "mouse2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐀",
      identifier: "rat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐹",
      identifier: "hamster",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐰",
      identifier: "rabbit",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐇",
      identifier: "rabbit2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐿️",
      identifier: "chipmunk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦫",
      identifier: "beaver",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦔",
      identifier: "hedgehog",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦇",
      identifier: "bat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐻",
      identifier: "bear",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐻‍❄️",
      identifier: "polar_bear",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐨",
      identifier: "koala",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐼",
      identifier: "panda_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦥",
      identifier: "sloth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦦",
      identifier: "otter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦨",
      identifier: "skunk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦘",
      identifier: "kangaroo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦡",
      identifier: "badger",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐾",
      identifier: "feet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦃",
      identifier: "turkey",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐔",
      identifier: "chicken",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐓",
      identifier: "rooster",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐣",
      identifier: "hatching_chick",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐤",
      identifier: "baby_chick",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐥",
      identifier: "hatched_chick",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐦",
      identifier: "bird",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐧",
      identifier: "penguin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕊️",
      identifier: "dove_of_peace",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦅",
      identifier: "eagle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦆",
      identifier: "duck",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦢",
      identifier: "swan",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦉",
      identifier: "owl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦤",
      identifier: "dodo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪶",
      identifier: "feather",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦩",
      identifier: "flamingo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦚",
      identifier: "peacock",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦜",
      identifier: "parrot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪽",
      identifier: "wing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐦‍⬛",
      identifier: "black_bird",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪿",
      identifier: "goose",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐦‍🔥",
      identifier: "phoenix",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐸",
      identifier: "frog",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐊",
      identifier: "crocodile",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐢",
      identifier: "turtle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦎",
      identifier: "lizard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐍",
      identifier: "snake",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐲",
      identifier: "dragon_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐉",
      identifier: "dragon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦕",
      identifier: "sauropod",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦖",
      identifier: "t-rex",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐳",
      identifier: "whale",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐋",
      identifier: "whale2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐬",
      identifier: "dolphin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦭",
      identifier: "seal",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐟",
      identifier: "fish",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐠",
      identifier: "tropical_fish",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐡",
      identifier: "blowfish",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦈",
      identifier: "shark",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐙",
      identifier: "octopus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐚",
      identifier: "shell",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪸",
      identifier: "coral",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪼",
      identifier: "jellyfish",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐌",
      identifier: "snail",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦋",
      identifier: "butterfly",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐛",
      identifier: "bug",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐜",
      identifier: "ant",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐝",
      identifier: "bee",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪲",
      identifier: "beetle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🐞",
      identifier: "ladybug",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦗",
      identifier: "cricket",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪳",
      identifier: "cockroach",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕷️",
      identifier: "spider",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕸️",
      identifier: "spider_web",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦂",
      identifier: "scorpion",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦟",
      identifier: "mosquito",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪰",
      identifier: "fly",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪱",
      identifier: "worm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦠",
      identifier: "microbe",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💐",
      identifier: "bouquet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌸",
      identifier: "cherry_blossom",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💮",
      identifier: "white_flower",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪷",
      identifier: "lotus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏵️",
      identifier: "rosette",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌹",
      identifier: "rose",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥀",
      identifier: "wilted_flower",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌺",
      identifier: "hibiscus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌻",
      identifier: "sunflower",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌼",
      identifier: "blossom",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌷",
      identifier: "tulip",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪻",
      identifier: "hyacinth",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌱",
      identifier: "seedling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪴",
      identifier: "potted_plant",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌲",
      identifier: "evergreen_tree",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌳",
      identifier: "deciduous_tree",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌴",
      identifier: "palm_tree",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌵",
      identifier: "cactus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌾",
      identifier: "ear_of_rice",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌿",
      identifier: "herb",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☘️",
      identifier: "shamrock",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍀",
      identifier: "four_leaf_clover",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍁",
      identifier: "maple_leaf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍂",
      identifier: "fallen_leaf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍃",
      identifier: "leaves",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪹",
      identifier: "empty_nest",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪺",
      identifier: "nest_with_eggs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍄",
      identifier: "mushroom",
      isEmojiBase: !0,
      supportedTwemoji: null
    }
  ],
  [
    {
      unicode: "🍇",
      identifier: "grapes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍈",
      identifier: "melon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍉",
      identifier: "watermelon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍊",
      identifier: "tangerine",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍋",
      identifier: "lemon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍋‍🟩",
      identifier: "lime",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍌",
      identifier: "banana",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍍",
      identifier: "pineapple",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥭",
      identifier: "mango",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍎",
      identifier: "apple",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍏",
      identifier: "green_apple",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍐",
      identifier: "pear",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍑",
      identifier: "peach",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍒",
      identifier: "cherries",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍓",
      identifier: "strawberry",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫐",
      identifier: "blueberries",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥝",
      identifier: "kiwifruit",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍅",
      identifier: "tomato",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫒",
      identifier: "olive",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥥",
      identifier: "coconut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥑",
      identifier: "avocado",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍆",
      identifier: "eggplant",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥔",
      identifier: "potato",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥕",
      identifier: "carrot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌽",
      identifier: "corn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌶️",
      identifier: "hot_pepper",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫑",
      identifier: "bell_pepper",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥒",
      identifier: "cucumber",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥬",
      identifier: "leafy_green",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥦",
      identifier: "broccoli",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧄",
      identifier: "garlic",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧅",
      identifier: "onion",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥜",
      identifier: "peanuts",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫘",
      identifier: "beans",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌰",
      identifier: "chestnut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫚",
      identifier: "ginger_root",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫛",
      identifier: "pea_pod",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍄‍🟫",
      identifier: "brown_mushroom",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍞",
      identifier: "bread",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥐",
      identifier: "croissant",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥖",
      identifier: "baguette_bread",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫓",
      identifier: "flatbread",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥨",
      identifier: "pretzel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥯",
      identifier: "bagel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥞",
      identifier: "pancakes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧇",
      identifier: "waffle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧀",
      identifier: "cheese_wedge",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍖",
      identifier: "meat_on_bone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍗",
      identifier: "poultry_leg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥩",
      identifier: "cut_of_meat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥓",
      identifier: "bacon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍔",
      identifier: "hamburger",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍟",
      identifier: "fries",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍕",
      identifier: "pizza",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌭",
      identifier: "hot_dog",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥪",
      identifier: "sandwich",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌮",
      identifier: "taco",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌯",
      identifier: "burrito",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫔",
      identifier: "tamale",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥙",
      identifier: "stuffed_flatbread",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧆",
      identifier: "falafel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥚",
      identifier: "egg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍳",
      identifier: "fried_egg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥘",
      identifier: "shallow_pan_of_food",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍲",
      identifier: "stew",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫕",
      identifier: "fondue",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥣",
      identifier: "bowl_with_spoon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥗",
      identifier: "green_salad",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍿",
      identifier: "popcorn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧈",
      identifier: "butter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧂",
      identifier: "salt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥫",
      identifier: "canned_food",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍱",
      identifier: "bento",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍘",
      identifier: "rice_cracker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍙",
      identifier: "rice_ball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍚",
      identifier: "rice",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍛",
      identifier: "curry",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍜",
      identifier: "ramen",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍝",
      identifier: "spaghetti",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍠",
      identifier: "sweet_potato",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍢",
      identifier: "oden",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍣",
      identifier: "sushi",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍤",
      identifier: "fried_shrimp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍥",
      identifier: "fish_cake",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥮",
      identifier: "moon_cake",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍡",
      identifier: "dango",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥟",
      identifier: "dumpling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥠",
      identifier: "fortune_cookie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥡",
      identifier: "takeout_box",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦀",
      identifier: "crab",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦞",
      identifier: "lobster",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦐",
      identifier: "shrimp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦑",
      identifier: "squid",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦪",
      identifier: "oyster",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍦",
      identifier: "icecream",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍧",
      identifier: "shaved_ice",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍨",
      identifier: "ice_cream",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍩",
      identifier: "doughnut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍪",
      identifier: "cookie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎂",
      identifier: "birthday",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍰",
      identifier: "cake",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧁",
      identifier: "cupcake",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥧",
      identifier: "pie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍫",
      identifier: "chocolate_bar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍬",
      identifier: "candy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍭",
      identifier: "lollipop",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍮",
      identifier: "custard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍯",
      identifier: "honey_pot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍼",
      identifier: "baby_bottle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥛",
      identifier: "glass_of_milk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☕",
      identifier: "coffee",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫖",
      identifier: "teapot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍵",
      identifier: "tea",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍶",
      identifier: "sake",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍾",
      identifier: "bottle_with_popping_cork",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍷",
      identifier: "wine_glass",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍸",
      identifier: "cocktail",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍹",
      identifier: "tropical_drink",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍺",
      identifier: "beer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍻",
      identifier: "beers",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥂",
      identifier: "clinking_glasses",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥃",
      identifier: "tumbler_glass",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫗",
      identifier: "pouring_liquid",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥤",
      identifier: "cup_with_straw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧋",
      identifier: "bubble_tea",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧃",
      identifier: "beverage_box",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧉",
      identifier: "mate_drink",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧊",
      identifier: "ice_cube",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥢",
      identifier: "chopsticks",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍽️",
      identifier: "knife_fork_plate",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🍴",
      identifier: "fork_and_knife",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥄",
      identifier: "spoon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔪",
      identifier: "hocho",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫙",
      identifier: "jar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏺",
      identifier: "amphora",
      isEmojiBase: !0,
      supportedTwemoji: null
    }
  ],
  [
    {
      unicode: "🌍",
      identifier: "earth_africa",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌎",
      identifier: "earth_americas",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌏",
      identifier: "earth_asia",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌐",
      identifier: "globe_with_meridians",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗺️",
      identifier: "world_map",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗾",
      identifier: "japan",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧭",
      identifier: "compass",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏔️",
      identifier: "snow_capped_mountain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛰️",
      identifier: "mountain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌋",
      identifier: "volcano",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗻",
      identifier: "mount_fuji",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏕️",
      identifier: "camping",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏖️",
      identifier: "beach_with_umbrella",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏜️",
      identifier: "desert",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏝️",
      identifier: "desert_island",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏞️",
      identifier: "national_park",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏟️",
      identifier: "stadium",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏛️",
      identifier: "classical_building",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏗️",
      identifier: "building_construction",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧱",
      identifier: "bricks",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪨",
      identifier: "rock",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪵",
      identifier: "wood",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛖",
      identifier: "hut",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏘️",
      identifier: "house_buildings",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏚️",
      identifier: "derelict_house_building",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏠",
      identifier: "house",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏡",
      identifier: "house_with_garden",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏢",
      identifier: "office",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏣",
      identifier: "post_office",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏤",
      identifier: "european_post_office",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏥",
      identifier: "hospital",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏦",
      identifier: "bank",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏨",
      identifier: "hotel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏩",
      identifier: "love_hotel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏪",
      identifier: "convenience_store",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏫",
      identifier: "school",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏬",
      identifier: "department_store",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏭",
      identifier: "factory",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏯",
      identifier: "japanese_castle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏰",
      identifier: "european_castle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💒",
      identifier: "wedding",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗼",
      identifier: "tokyo_tower",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗽",
      identifier: "statue_of_liberty",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛪",
      identifier: "church",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕌",
      identifier: "mosque",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛕",
      identifier: "hindu_temple",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕍",
      identifier: "synagogue",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛩️",
      identifier: "shinto_shrine",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕋",
      identifier: "kaaba",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛲",
      identifier: "fountain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛺",
      identifier: "tent",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌁",
      identifier: "foggy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌃",
      identifier: "night_with_stars",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏙️",
      identifier: "cityscape",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌄",
      identifier: "sunrise_over_mountains",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌅",
      identifier: "sunrise",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌆",
      identifier: "city_sunset",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌇",
      identifier: "city_sunrise",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌉",
      identifier: "bridge_at_night",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♨️",
      identifier: "hotsprings",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎠",
      identifier: "carousel_horse",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛝",
      identifier: "playground_slide",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎡",
      identifier: "ferris_wheel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎢",
      identifier: "roller_coaster",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💈",
      identifier: "barber",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎪",
      identifier: "circus_tent",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚂",
      identifier: "steam_locomotive",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚃",
      identifier: "railway_car",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚄",
      identifier: "bullettrain_side",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚅",
      identifier: "bullettrain_front",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚆",
      identifier: "train2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚇",
      identifier: "metro",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚈",
      identifier: "light_rail",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚉",
      identifier: "station",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚊",
      identifier: "tram",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚝",
      identifier: "monorail",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚞",
      identifier: "mountain_railway",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚋",
      identifier: "train",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚌",
      identifier: "bus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚍",
      identifier: "oncoming_bus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚎",
      identifier: "trolleybus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚐",
      identifier: "minibus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚑",
      identifier: "ambulance",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚒",
      identifier: "fire_engine",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚓",
      identifier: "police_car",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚔",
      identifier: "oncoming_police_car",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚕",
      identifier: "taxi",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚖",
      identifier: "oncoming_taxi",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚗",
      identifier: "car",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚘",
      identifier: "oncoming_automobile",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚙",
      identifier: "blue_car",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛻",
      identifier: "pickup_truck",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚚",
      identifier: "truck",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚛",
      identifier: "articulated_lorry",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚜",
      identifier: "tractor",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏎️",
      identifier: "racing_car",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏍️",
      identifier: "racing_motorcycle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛵",
      identifier: "motor_scooter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦽",
      identifier: "manual_wheelchair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦼",
      identifier: "motorized_wheelchair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛺",
      identifier: "auto_rickshaw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚲",
      identifier: "bike",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛴",
      identifier: "scooter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛹",
      identifier: "skateboard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛼",
      identifier: "roller_skate",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚏",
      identifier: "busstop",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛣️",
      identifier: "motorway",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛤️",
      identifier: "railway_track",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛢️",
      identifier: "oil_drum",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛽",
      identifier: "fuelpump",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛞",
      identifier: "wheel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚨",
      identifier: "rotating_light",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚥",
      identifier: "traffic_light",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚦",
      identifier: "vertical_traffic_light",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛑",
      identifier: "octagonal_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚧",
      identifier: "construction",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚓",
      identifier: "anchor",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛟",
      identifier: "ring_buoy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛵",
      identifier: "boat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛶",
      identifier: "canoe",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚤",
      identifier: "speedboat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛳️",
      identifier: "passenger_ship",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛴️",
      identifier: "ferry",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛥️",
      identifier: "motor_boat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚢",
      identifier: "ship",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✈️",
      identifier: "airplane",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛩️",
      identifier: "small_airplane",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛫",
      identifier: "airplane_departure",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛬",
      identifier: "airplane_arriving",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪂",
      identifier: "parachute",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💺",
      identifier: "seat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚁",
      identifier: "helicopter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚟",
      identifier: "suspension_railway",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚠",
      identifier: "mountain_cableway",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚡",
      identifier: "aerial_tramway",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛰️",
      identifier: "satellite",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚀",
      identifier: "rocket",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛸",
      identifier: "flying_saucer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛎️",
      identifier: "bellhop_bell",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧳",
      identifier: "luggage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⌛",
      identifier: "hourglass",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏳",
      identifier: "hourglass_flowing_sand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⌚",
      identifier: "watch",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏰",
      identifier: "alarm_clock",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏱️",
      identifier: "stopwatch",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏲️",
      identifier: "timer_clock",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕰️",
      identifier: "mantelpiece_clock",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕛",
      identifier: "clock12",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕧",
      identifier: "clock1230",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕐",
      identifier: "clock1",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕜",
      identifier: "clock130",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕑",
      identifier: "clock2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕝",
      identifier: "clock230",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕒",
      identifier: "clock3",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕞",
      identifier: "clock330",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕓",
      identifier: "clock4",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕟",
      identifier: "clock430",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕔",
      identifier: "clock5",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕠",
      identifier: "clock530",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕕",
      identifier: "clock6",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕡",
      identifier: "clock630",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕖",
      identifier: "clock7",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕢",
      identifier: "clock730",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕗",
      identifier: "clock8",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕣",
      identifier: "clock830",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕘",
      identifier: "clock9",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕤",
      identifier: "clock930",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕙",
      identifier: "clock10",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕥",
      identifier: "clock1030",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕚",
      identifier: "clock11",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕦",
      identifier: "clock1130",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌑",
      identifier: "new_moon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌒",
      identifier: "waxing_crescent_moon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌓",
      identifier: "first_quarter_moon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌔",
      identifier: "moon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌕",
      identifier: "full_moon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌖",
      identifier: "waning_gibbous_moon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌗",
      identifier: "last_quarter_moon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌘",
      identifier: "waning_crescent_moon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌙",
      identifier: "crescent_moon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌚",
      identifier: "new_moon_with_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌛",
      identifier: "first_quarter_moon_with_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌜",
      identifier: "last_quarter_moon_with_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌡️",
      identifier: "thermometer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☀️",
      identifier: "sunny",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌝",
      identifier: "full_moon_with_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌞",
      identifier: "sun_with_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪐",
      identifier: "ringed_planet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⭐",
      identifier: "star",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌟",
      identifier: "star2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌠",
      identifier: "stars",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌌",
      identifier: "milky_way",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☁️",
      identifier: "cloud",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛅",
      identifier: "partly_sunny",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛈️",
      identifier: "thunder_cloud_and_rain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌤️",
      identifier: "mostly_sunny",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌥️",
      identifier: "barely_sunny",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌦️",
      identifier: "partly_sunny_rain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌧️",
      identifier: "rain_cloud",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌨️",
      identifier: "snow_cloud",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌩️",
      identifier: "lightning",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌪️",
      identifier: "tornado",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌫️",
      identifier: "fog",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌬️",
      identifier: "wind_blowing_face",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌀",
      identifier: "cyclone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌈",
      identifier: "rainbow",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌂",
      identifier: "closed_umbrella",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☂️",
      identifier: "umbrella",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☔",
      identifier: "umbrella_with_rain_drops",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛱️",
      identifier: "umbrella_on_ground",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚡",
      identifier: "zap",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❄️",
      identifier: "snowflake",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☃️",
      identifier: "snowman",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛄",
      identifier: "snowman_without_snow",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☄️",
      identifier: "comet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔥",
      identifier: "fire",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💧",
      identifier: "droplet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🌊",
      identifier: "ocean",
      isEmojiBase: !0,
      supportedTwemoji: null
    }
  ],
  [
    {
      unicode: "🎃",
      identifier: "jack_o_lantern",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎄",
      identifier: "christmas_tree",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎆",
      identifier: "fireworks",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎇",
      identifier: "sparkler",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧨",
      identifier: "firecracker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✨",
      identifier: "sparkles",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎈",
      identifier: "balloon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎉",
      identifier: "tada",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎊",
      identifier: "confetti_ball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎋",
      identifier: "tanabata_tree",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎍",
      identifier: "bamboo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎎",
      identifier: "dolls",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎏",
      identifier: "flags",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎐",
      identifier: "wind_chime",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎑",
      identifier: "rice_scene",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧧",
      identifier: "red_envelope",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎀",
      identifier: "ribbon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎁",
      identifier: "gift",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎗️",
      identifier: "reminder_ribbon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎟️",
      identifier: "admission_tickets",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎫",
      identifier: "ticket",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎖️",
      identifier: "medal",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏆",
      identifier: "trophy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏅",
      identifier: "sports_medal",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥇",
      identifier: "first_place_medal",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥈",
      identifier: "second_place_medal",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥉",
      identifier: "third_place_medal",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚽",
      identifier: "soccer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚾",
      identifier: "baseball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥎",
      identifier: "softball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏀",
      identifier: "basketball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏐",
      identifier: "volleyball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏈",
      identifier: "football",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏉",
      identifier: "rugby_football",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎾",
      identifier: "tennis",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥏",
      identifier: "flying_disc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎳",
      identifier: "bowling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏏",
      identifier: "cricket_game",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏑",
      identifier: "field_hockey",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏒",
      identifier: "ice_hockey",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥍",
      identifier: "lacrosse",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏓",
      identifier: "ping_pong",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏸",
      identifier: "badminton",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥊",
      identifier: "boxing_glove",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥋",
      identifier: "martial_arts_uniform",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥅",
      identifier: "goal_net",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛳",
      identifier: "golf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛸️",
      identifier: "ice_skate",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎣",
      identifier: "fishing_pole_and_fish",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🤿",
      identifier: "diving_mask",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎽",
      identifier: "running_shirt_with_sash",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎿",
      identifier: "ski",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛷",
      identifier: "sled",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥌",
      identifier: "curling_stone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎯",
      identifier: "dart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪀",
      identifier: "yo-yo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪁",
      identifier: "kite",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔫",
      identifier: "gun",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎱",
      identifier: "8ball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔮",
      identifier: "crystal_ball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪄",
      identifier: "magic_wand",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎮",
      identifier: "video_game",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕹️",
      identifier: "joystick",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎰",
      identifier: "slot_machine",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎲",
      identifier: "game_die",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧩",
      identifier: "jigsaw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧸",
      identifier: "teddy_bear",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪅",
      identifier: "pinata",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪩",
      identifier: "mirror_ball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪆",
      identifier: "nesting_dolls",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♠️",
      identifier: "spades",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♥️",
      identifier: "hearts",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♦️",
      identifier: "diamonds",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♣️",
      identifier: "clubs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♟️",
      identifier: "chess_pawn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🃏",
      identifier: "black_joker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🀄",
      identifier: "mahjong",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎴",
      identifier: "flower_playing_cards",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎭",
      identifier: "performing_arts",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖼️",
      identifier: "frame_with_picture",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎨",
      identifier: "art",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧵",
      identifier: "thread",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪡",
      identifier: "sewing_needle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧶",
      identifier: "yarn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪢",
      identifier: "knot",
      isEmojiBase: !0,
      supportedTwemoji: null
    }
  ],
  [
    {
      unicode: "👓",
      identifier: "eyeglasses",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕶️",
      identifier: "dark_sunglasses",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥽",
      identifier: "goggles",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥼",
      identifier: "lab_coat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦺",
      identifier: "safety_vest",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👔",
      identifier: "necktie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👕",
      identifier: "shirt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👖",
      identifier: "jeans",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧣",
      identifier: "scarf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧤",
      identifier: "gloves",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧥",
      identifier: "coat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧦",
      identifier: "socks",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👗",
      identifier: "dress",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👘",
      identifier: "kimono",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥻",
      identifier: "sari",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩱",
      identifier: "one-piece_swimsuit",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩲",
      identifier: "briefs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩳",
      identifier: "shorts",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👙",
      identifier: "bikini",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👚",
      identifier: "womans_clothes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪭",
      identifier: "folding_hand_fan",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👛",
      identifier: "purse",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👜",
      identifier: "handbag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👝",
      identifier: "pouch",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛍️",
      identifier: "shopping_bags",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎒",
      identifier: "school_satchel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩴",
      identifier: "thong_sandal",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👞",
      identifier: "mans_shoe",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👟",
      identifier: "athletic_shoe",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥾",
      identifier: "hiking_boot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥿",
      identifier: "womans_flat_shoe",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👠",
      identifier: "high_heel",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👡",
      identifier: "sandal",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩰",
      identifier: "ballet_shoes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👢",
      identifier: "boot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪮",
      identifier: "hair_pick",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👑",
      identifier: "crown",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "👒",
      identifier: "womans_hat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎩",
      identifier: "tophat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎓",
      identifier: "mortar_board",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧢",
      identifier: "billed_cap",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪖",
      identifier: "military_helmet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛑️",
      identifier: "helmet_with_white_cross",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📿",
      identifier: "prayer_beads",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💄",
      identifier: "lipstick",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💍",
      identifier: "ring",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💎",
      identifier: "gem",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔇",
      identifier: "mute",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔈",
      identifier: "speaker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔉",
      identifier: "sound",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔊",
      identifier: "loud_sound",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📢",
      identifier: "loudspeaker",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📣",
      identifier: "mega",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📯",
      identifier: "postal_horn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔔",
      identifier: "bell",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔕",
      identifier: "no_bell",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎼",
      identifier: "musical_score",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎵",
      identifier: "musical_note",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎶",
      identifier: "notes",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎙️",
      identifier: "studio_microphone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎚️",
      identifier: "level_slider",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎛️",
      identifier: "control_knobs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎤",
      identifier: "microphone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎧",
      identifier: "headphones",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📻",
      identifier: "radio",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎷",
      identifier: "saxophone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪗",
      identifier: "accordion",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎸",
      identifier: "guitar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎹",
      identifier: "musical_keyboard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎺",
      identifier: "trumpet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎻",
      identifier: "violin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪕",
      identifier: "banjo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🥁",
      identifier: "drum_with_drumsticks",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪘",
      identifier: "long_drum",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪇",
      identifier: "maracas",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪈",
      identifier: "flute",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📱",
      identifier: "iphone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📲",
      identifier: "calling",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☎️",
      identifier: "phone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📞",
      identifier: "telephone_receiver",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📟",
      identifier: "pager",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📠",
      identifier: "fax",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔋",
      identifier: "battery",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪫",
      identifier: "low_battery",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔌",
      identifier: "electric_plug",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💻",
      identifier: "computer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖥️",
      identifier: "desktop_computer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖨️",
      identifier: "printer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⌨️",
      identifier: "keyboard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖱️",
      identifier: "three_button_mouse",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖲️",
      identifier: "trackball",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💽",
      identifier: "minidisc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💾",
      identifier: "floppy_disk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💿",
      identifier: "cd",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📀",
      identifier: "dvd",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧮",
      identifier: "abacus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎥",
      identifier: "movie_camera",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎞️",
      identifier: "film_frames",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📽️",
      identifier: "film_projector",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎬",
      identifier: "clapper",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📺",
      identifier: "tv",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📷",
      identifier: "camera",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📸",
      identifier: "camera_with_flash",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📹",
      identifier: "video_camera",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📼",
      identifier: "vhs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔍",
      identifier: "mag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔎",
      identifier: "mag_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕯️",
      identifier: "candle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💡",
      identifier: "bulb",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔦",
      identifier: "flashlight",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏮",
      identifier: "izakaya_lantern",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪔",
      identifier: "diya_lamp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📔",
      identifier: "notebook_with_decorative_cover",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📕",
      identifier: "closed_book",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📖",
      identifier: "book",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📗",
      identifier: "green_book",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📘",
      identifier: "blue_book",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📙",
      identifier: "orange_book",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📚",
      identifier: "books",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📓",
      identifier: "notebook",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📒",
      identifier: "ledger",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📃",
      identifier: "page_with_curl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📜",
      identifier: "scroll",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📄",
      identifier: "page_facing_up",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📰",
      identifier: "newspaper",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗞️",
      identifier: "rolled_up_newspaper",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📑",
      identifier: "bookmark_tabs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔖",
      identifier: "bookmark",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏷️",
      identifier: "label",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💰",
      identifier: "moneybag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪙",
      identifier: "coin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💴",
      identifier: "yen",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💵",
      identifier: "dollar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💶",
      identifier: "euro",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💷",
      identifier: "pound",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💸",
      identifier: "money_with_wings",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💳",
      identifier: "credit_card",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧾",
      identifier: "receipt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💹",
      identifier: "chart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✉️",
      identifier: "email",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📧",
      identifier: "e-mail",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📨",
      identifier: "incoming_envelope",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📩",
      identifier: "envelope_with_arrow",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📤",
      identifier: "outbox_tray",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📥",
      identifier: "inbox_tray",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📦",
      identifier: "package",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📫",
      identifier: "mailbox",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📪",
      identifier: "mailbox_closed",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📬",
      identifier: "mailbox_with_mail",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📭",
      identifier: "mailbox_with_no_mail",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📮",
      identifier: "postbox",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗳️",
      identifier: "ballot_box_with_ballot",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✏️",
      identifier: "pencil2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✒️",
      identifier: "black_nib",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖋️",
      identifier: "lower_left_fountain_pen",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖊️",
      identifier: "lower_left_ballpoint_pen",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖌️",
      identifier: "lower_left_paintbrush",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖍️",
      identifier: "lower_left_crayon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📝",
      identifier: "memo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💼",
      identifier: "briefcase",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📁",
      identifier: "file_folder",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📂",
      identifier: "open_file_folder",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗂️",
      identifier: "card_index_dividers",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📅",
      identifier: "date",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📆",
      identifier: "calendar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗒️",
      identifier: "spiral_note_pad",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗓️",
      identifier: "spiral_calendar_pad",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📇",
      identifier: "card_index",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📈",
      identifier: "chart_with_upwards_trend",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📉",
      identifier: "chart_with_downwards_trend",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📊",
      identifier: "bar_chart",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📋",
      identifier: "clipboard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📌",
      identifier: "pushpin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📍",
      identifier: "round_pushpin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📎",
      identifier: "paperclip",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🖇️",
      identifier: "linked_paperclips",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📏",
      identifier: "straight_ruler",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📐",
      identifier: "triangular_ruler",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✂️",
      identifier: "scissors",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗃️",
      identifier: "card_file_box",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗄️",
      identifier: "file_cabinet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗑️",
      identifier: "wastebasket",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔒",
      identifier: "lock",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔓",
      identifier: "unlock",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔏",
      identifier: "lock_with_ink_pen",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔐",
      identifier: "closed_lock_with_key",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔑",
      identifier: "key",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗝️",
      identifier: "old_key",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔨",
      identifier: "hammer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪓",
      identifier: "axe",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛏️",
      identifier: "pick",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚒️",
      identifier: "hammer_and_pick",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛠️",
      identifier: "hammer_and_wrench",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗡️",
      identifier: "dagger_knife",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚔️",
      identifier: "crossed_swords",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💣",
      identifier: "bomb",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪃",
      identifier: "boomerang",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏹",
      identifier: "bow_and_arrow",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛡️",
      identifier: "shield",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪚",
      identifier: "carpentry_saw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔧",
      identifier: "wrench",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪛",
      identifier: "screwdriver",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔩",
      identifier: "nut_and_bolt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚙️",
      identifier: "gear",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗜️",
      identifier: "compression",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚖️",
      identifier: "scales",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🦯",
      identifier: "probing_cane",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔗",
      identifier: "link",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛓️‍💥",
      identifier: "broken_chain",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛓️",
      identifier: "chains",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪝",
      identifier: "hook",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧰",
      identifier: "toolbox",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧲",
      identifier: "magnet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪜",
      identifier: "ladder",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚗️",
      identifier: "alembic",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧪",
      identifier: "test_tube",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧫",
      identifier: "petri_dish",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧬",
      identifier: "dna",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔬",
      identifier: "microscope",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔭",
      identifier: "telescope",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📡",
      identifier: "satellite_antenna",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💉",
      identifier: "syringe",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩸",
      identifier: "drop_of_blood",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💊",
      identifier: "pill",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩹",
      identifier: "adhesive_bandage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩼",
      identifier: "crutch",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩺",
      identifier: "stethoscope",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🩻",
      identifier: "x-ray",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚪",
      identifier: "door",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛗",
      identifier: "elevator",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪞",
      identifier: "mirror",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪟",
      identifier: "window",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛏️",
      identifier: "bed",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛋️",
      identifier: "couch_and_lamp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪑",
      identifier: "chair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚽",
      identifier: "toilet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪠",
      identifier: "plunger",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚿",
      identifier: "shower",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛁",
      identifier: "bathtub",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪤",
      identifier: "mouse_trap",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪒",
      identifier: "razor",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧴",
      identifier: "lotion_bottle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧷",
      identifier: "safety_pin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧹",
      identifier: "broom",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧺",
      identifier: "basket",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧻",
      identifier: "roll_of_paper",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪣",
      identifier: "bucket",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧼",
      identifier: "soap",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🫧",
      identifier: "bubbles",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪥",
      identifier: "toothbrush",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧽",
      identifier: "sponge",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧯",
      identifier: "fire_extinguisher",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛒",
      identifier: "shopping_trolley",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚬",
      identifier: "smoking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚰️",
      identifier: "coffin",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪦",
      identifier: "headstone",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚱️",
      identifier: "funeral_urn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🧿",
      identifier: "nazar_amulet",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪬",
      identifier: "hamsa",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🗿",
      identifier: "moyai",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪧",
      identifier: "placard",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪪",
      identifier: "identification_card",
      isEmojiBase: !0,
      supportedTwemoji: null
    }
  ],
  [
    {
      unicode: "🏧",
      identifier: "atm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚮",
      identifier: "put_litter_in_its_place",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚰",
      identifier: "potable_water",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♿",
      identifier: "wheelchair",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚹",
      identifier: "mens",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚺",
      identifier: "womens",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚻",
      identifier: "restroom",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚼",
      identifier: "baby_symbol",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚾",
      identifier: "wc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛂",
      identifier: "passport_control",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛃",
      identifier: "customs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛄",
      identifier: "baggage_claim",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛅",
      identifier: "left_luggage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚠️",
      identifier: "warning",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚸",
      identifier: "children_crossing",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛔",
      identifier: "no_entry",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚫",
      identifier: "no_entry_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚳",
      identifier: "no_bicycles",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚭",
      identifier: "no_smoking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚯",
      identifier: "do_not_litter",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚱",
      identifier: "non-potable_water",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚷",
      identifier: "no_pedestrians",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📵",
      identifier: "no_mobile_phones",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔞",
      identifier: "underage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☢️",
      identifier: "radioactive_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☣️",
      identifier: "biohazard_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⬆️",
      identifier: "arrow_up",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "↗️",
      identifier: "arrow_upper_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "➡️",
      identifier: "arrow_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "↘️",
      identifier: "arrow_lower_right",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⬇️",
      identifier: "arrow_down",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "↙️",
      identifier: "arrow_lower_left",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⬅️",
      identifier: "arrow_left",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "↖️",
      identifier: "arrow_upper_left",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "↕️",
      identifier: "arrow_up_down",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "↔️",
      identifier: "left_right_arrow",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "↩️",
      identifier: "leftwards_arrow_with_hook",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "↪️",
      identifier: "arrow_right_hook",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⤴️",
      identifier: "arrow_heading_up",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⤵️",
      identifier: "arrow_heading_down",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔃",
      identifier: "arrows_clockwise",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔄",
      identifier: "arrows_counterclockwise",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔙",
      identifier: "back",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔚",
      identifier: "end",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔛",
      identifier: "on",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔜",
      identifier: "soon",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔝",
      identifier: "top",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛐",
      identifier: "place_of_worship",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚛️",
      identifier: "atom_symbol",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕉️",
      identifier: "om_symbol",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✡️",
      identifier: "star_of_david",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☸️",
      identifier: "wheel_of_dharma",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☯️",
      identifier: "yin_yang",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✝️",
      identifier: "latin_cross",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☦️",
      identifier: "orthodox_cross",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☪️",
      identifier: "star_and_crescent",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☮️",
      identifier: "peace_symbol",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🕎",
      identifier: "menorah",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔯",
      identifier: "six_pointed_star",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🪯",
      identifier: "khanda",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♈",
      identifier: "aries",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♉",
      identifier: "taurus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♊",
      identifier: "gemini",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♋",
      identifier: "cancer",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♌",
      identifier: "leo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♍",
      identifier: "virgo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♎",
      identifier: "libra",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♏",
      identifier: "scorpius",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♐",
      identifier: "sagittarius",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♑",
      identifier: "capricorn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♒",
      identifier: "aquarius",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♓",
      identifier: "pisces",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⛎",
      identifier: "ophiuchus",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔀",
      identifier: "twisted_rightwards_arrows",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔁",
      identifier: "repeat",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔂",
      identifier: "repeat_one",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "▶️",
      identifier: "arrow_forward",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏩",
      identifier: "fast_forward",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏭️",
      identifier: "black_right_pointing_double_triangle_with_vertical_bar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏯️",
      identifier: "black_right_pointing_triangle_with_double_vertical_bar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "◀️",
      identifier: "arrow_backward",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏪",
      identifier: "rewind",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏮️",
      identifier: "black_left_pointing_double_triangle_with_vertical_bar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔼",
      identifier: "arrow_up_small",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏫",
      identifier: "arrow_double_up",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔽",
      identifier: "arrow_down_small",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏬",
      identifier: "arrow_double_down",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏸️",
      identifier: "double_vertical_bar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏹️",
      identifier: "black_square_for_stop",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏺️",
      identifier: "black_circle_for_record",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⏏️",
      identifier: "eject",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎦",
      identifier: "cinema",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔅",
      identifier: "low_brightness",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔆",
      identifier: "high_brightness",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📶",
      identifier: "signal_strength",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🛜",
      identifier: "wireless",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📳",
      identifier: "vibration_mode",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📴",
      identifier: "mobile_phone_off",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♀️",
      identifier: "female_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♂️",
      identifier: "male_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚧️",
      identifier: "transgender_symbol",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✖️",
      identifier: "heavy_multiplication_x",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "➕",
      identifier: "heavy_plus_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "➖",
      identifier: "heavy_minus_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "➗",
      identifier: "heavy_division_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟰",
      identifier: "heavy_equals_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♾️",
      identifier: "infinity",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "‼️",
      identifier: "bangbang",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⁉️",
      identifier: "interrobang",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❓",
      identifier: "question",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❔",
      identifier: "grey_question",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❕",
      identifier: "grey_exclamation",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❗",
      identifier: "exclamation",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "〰️",
      identifier: "wavy_dash",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💱",
      identifier: "currency_exchange",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💲",
      identifier: "heavy_dollar_sign",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚕️",
      identifier: "medical_symbol",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "♻️",
      identifier: "recycle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚜️",
      identifier: "fleur_de_lis",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔱",
      identifier: "trident",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "📛",
      identifier: "name_badge",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔰",
      identifier: "beginner",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⭕",
      identifier: "o",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✅",
      identifier: "white_check_mark",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "☑️",
      identifier: "ballot_box_with_check",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✔️",
      identifier: "heavy_check_mark",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❌",
      identifier: "x",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❎",
      identifier: "negative_squared_cross_mark",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "➰",
      identifier: "curly_loop",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "➿",
      identifier: "loop",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "〽️",
      identifier: "part_alternation_mark",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✳️",
      identifier: "eight_spoked_asterisk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "✴️",
      identifier: "eight_pointed_black_star",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "❇️",
      identifier: "sparkle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "©️",
      identifier: "copyright",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "®️",
      identifier: "registered",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "™️",
      identifier: "tm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "#️⃣",
      identifier: "hash",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "*️⃣",
      identifier: "keycap_star",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "0️⃣",
      identifier: "zero",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "1️⃣",
      identifier: "one",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "2️⃣",
      identifier: "two",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "3️⃣",
      identifier: "three",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "4️⃣",
      identifier: "four",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "5️⃣",
      identifier: "five",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "6️⃣",
      identifier: "six",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "7️⃣",
      identifier: "seven",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "8️⃣",
      identifier: "eight",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "9️⃣",
      identifier: "nine",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔟",
      identifier: "keycap_ten",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔠",
      identifier: "capital_abcd",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔡",
      identifier: "abcd",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔢",
      identifier: "1234",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔣",
      identifier: "symbols",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔤",
      identifier: "abc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🅰️",
      identifier: "a",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆎",
      identifier: "ab",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🅱️",
      identifier: "b",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆑",
      identifier: "cl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆒",
      identifier: "cool",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆓",
      identifier: "free",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "ℹ️",
      identifier: "information_source",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆔",
      identifier: "id",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "Ⓜ️",
      identifier: "m",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆕",
      identifier: "new",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆖",
      identifier: "ng",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🅾️",
      identifier: "o2",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆗",
      identifier: "ok",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🅿️",
      identifier: "parking",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆘",
      identifier: "sos",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆙",
      identifier: "up",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🆚",
      identifier: "vs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈁",
      identifier: "koko",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈂️",
      identifier: "sa",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈷️",
      identifier: "u6708",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈶",
      identifier: "u6709",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈯",
      identifier: "u6307",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🉐",
      identifier: "ideograph_advantage",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈹",
      identifier: "u5272",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈚",
      identifier: "u7121",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈲",
      identifier: "u7981",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🉑",
      identifier: "accept",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈸",
      identifier: "u7533",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈴",
      identifier: "u5408",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈳",
      identifier: "u7a7a",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "㊗️",
      identifier: "congratulations",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "㊙️",
      identifier: "secret",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈺",
      identifier: "u55b6",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🈵",
      identifier: "u6e80",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔴",
      identifier: "red_circle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟠",
      identifier: "large_orange_circle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟡",
      identifier: "large_yellow_circle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟢",
      identifier: "large_green_circle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔵",
      identifier: "large_blue_circle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟣",
      identifier: "large_purple_circle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟤",
      identifier: "large_brown_circle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚫",
      identifier: "black_circle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⚪",
      identifier: "white_circle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟥",
      identifier: "large_red_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟧",
      identifier: "large_orange_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟨",
      identifier: "large_yellow_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟩",
      identifier: "large_green_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟦",
      identifier: "large_blue_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟪",
      identifier: "large_purple_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🟫",
      identifier: "large_brown_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⬛",
      identifier: "black_large_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "⬜",
      identifier: "white_large_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "◼️",
      identifier: "black_medium_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "◻️",
      identifier: "white_medium_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "◾",
      identifier: "black_medium_small_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "◽",
      identifier: "white_medium_small_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "▪️",
      identifier: "black_small_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "▫️",
      identifier: "white_small_square",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔶",
      identifier: "large_orange_diamond",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔷",
      identifier: "large_blue_diamond",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔸",
      identifier: "small_orange_diamond",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔹",
      identifier: "small_blue_diamond",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔺",
      identifier: "small_red_triangle",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔻",
      identifier: "small_red_triangle_down",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "💠",
      identifier: "diamond_shape_with_a_dot_inside",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔘",
      identifier: "radio_button",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔳",
      identifier: "white_square_button",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🔲",
      identifier: "black_square_button",
      isEmojiBase: !0,
      supportedTwemoji: null
    }
  ],
  [
    {
      unicode: "🏁",
      identifier: "checkered_flag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🚩",
      identifier: "triangular_flag_on_post",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🎌",
      identifier: "crossed_flags",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏴",
      identifier: "black_flag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏳️",
      identifier: "waving_white_flag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏳️‍🌈",
      identifier: "rainbow-flag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏳️‍⚧️",
      identifier: "transgender_flag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏴‍☠️",
      identifier: "pirate_flag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇨",
      identifier: "flag-ac",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇩",
      identifier: "flag-ad",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇪",
      identifier: "flag-ae",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇫",
      identifier: "flag-af",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇬",
      identifier: "flag-ag",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇮",
      identifier: "flag-ai",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇱",
      identifier: "flag-al",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇲",
      identifier: "flag-am",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇴",
      identifier: "flag-ao",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇶",
      identifier: "flag-aq",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇷",
      identifier: "flag-ar",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇸",
      identifier: "flag-as",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇹",
      identifier: "flag-at",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇺",
      identifier: "flag-au",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇼",
      identifier: "flag-aw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇽",
      identifier: "flag-ax",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇦🇿",
      identifier: "flag-az",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇦",
      identifier: "flag-ba",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇧",
      identifier: "flag-bb",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇩",
      identifier: "flag-bd",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇪",
      identifier: "flag-be",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇫",
      identifier: "flag-bf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇬",
      identifier: "flag-bg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇭",
      identifier: "flag-bh",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇮",
      identifier: "flag-bi",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇯",
      identifier: "flag-bj",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇱",
      identifier: "flag-bl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇲",
      identifier: "flag-bm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇳",
      identifier: "flag-bn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇴",
      identifier: "flag-bo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇶",
      identifier: "flag-bq",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇷",
      identifier: "flag-br",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇸",
      identifier: "flag-bs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇹",
      identifier: "flag-bt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇻",
      identifier: "flag-bv",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇼",
      identifier: "flag-bw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇾",
      identifier: "flag-by",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇧🇿",
      identifier: "flag-bz",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇦",
      identifier: "flag-ca",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇨",
      identifier: "flag-cc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇩",
      identifier: "flag-cd",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇫",
      identifier: "flag-cf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇬",
      identifier: "flag-cg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇭",
      identifier: "flag-ch",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇮",
      identifier: "flag-ci",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇰",
      identifier: "flag-ck",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇱",
      identifier: "flag-cl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇲",
      identifier: "flag-cm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇳",
      identifier: "cn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇴",
      identifier: "flag-co",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇵",
      identifier: "flag-cp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇷",
      identifier: "flag-cr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇺",
      identifier: "flag-cu",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇻",
      identifier: "flag-cv",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇼",
      identifier: "flag-cw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇽",
      identifier: "flag-cx",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇾",
      identifier: "flag-cy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇨🇿",
      identifier: "flag-cz",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇩🇪",
      identifier: "de",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇩🇬",
      identifier: "flag-dg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇩🇯",
      identifier: "flag-dj",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇩🇰",
      identifier: "flag-dk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇩🇲",
      identifier: "flag-dm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇩🇴",
      identifier: "flag-do",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇩🇿",
      identifier: "flag-dz",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇪🇦",
      identifier: "flag-ea",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇪🇨",
      identifier: "flag-ec",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇪🇪",
      identifier: "flag-ee",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇪🇬",
      identifier: "flag-eg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇪🇭",
      identifier: "flag-eh",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇪🇷",
      identifier: "flag-er",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇪🇸",
      identifier: "es",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇪🇹",
      identifier: "flag-et",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇪🇺",
      identifier: "flag-eu",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇫🇮",
      identifier: "flag-fi",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇫🇯",
      identifier: "flag-fj",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇫🇰",
      identifier: "flag-fk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇫🇲",
      identifier: "flag-fm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇫🇴",
      identifier: "flag-fo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇫🇷",
      identifier: "fr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇦",
      identifier: "flag-ga",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇧",
      identifier: "gb",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇩",
      identifier: "flag-gd",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇪",
      identifier: "flag-ge",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇫",
      identifier: "flag-gf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇬",
      identifier: "flag-gg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇭",
      identifier: "flag-gh",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇮",
      identifier: "flag-gi",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇱",
      identifier: "flag-gl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇲",
      identifier: "flag-gm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇳",
      identifier: "flag-gn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇵",
      identifier: "flag-gp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇶",
      identifier: "flag-gq",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇷",
      identifier: "flag-gr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇸",
      identifier: "flag-gs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇹",
      identifier: "flag-gt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇺",
      identifier: "flag-gu",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇼",
      identifier: "flag-gw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇬🇾",
      identifier: "flag-gy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇭🇰",
      identifier: "flag-hk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇭🇲",
      identifier: "flag-hm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇭🇳",
      identifier: "flag-hn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇭🇷",
      identifier: "flag-hr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇭🇹",
      identifier: "flag-ht",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇭🇺",
      identifier: "flag-hu",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇨",
      identifier: "flag-ic",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇩",
      identifier: "flag-id",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇪",
      identifier: "flag-ie",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇱",
      identifier: "flag-il",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇲",
      identifier: "flag-im",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇳",
      identifier: "flag-in",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇴",
      identifier: "flag-io",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇶",
      identifier: "flag-iq",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇷",
      identifier: "flag-ir",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇸",
      identifier: "flag-is",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇮🇹",
      identifier: "it",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇯🇪",
      identifier: "flag-je",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇯🇲",
      identifier: "flag-jm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇯🇴",
      identifier: "flag-jo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇯🇵",
      identifier: "jp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇪",
      identifier: "flag-ke",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇬",
      identifier: "flag-kg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇭",
      identifier: "flag-kh",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇮",
      identifier: "flag-ki",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇲",
      identifier: "flag-km",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇳",
      identifier: "flag-kn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇵",
      identifier: "flag-kp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇷",
      identifier: "kr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇼",
      identifier: "flag-kw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇾",
      identifier: "flag-ky",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇰🇿",
      identifier: "flag-kz",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇦",
      identifier: "flag-la",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇧",
      identifier: "flag-lb",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇨",
      identifier: "flag-lc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇮",
      identifier: "flag-li",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇰",
      identifier: "flag-lk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇷",
      identifier: "flag-lr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇸",
      identifier: "flag-ls",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇹",
      identifier: "flag-lt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇺",
      identifier: "flag-lu",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇻",
      identifier: "flag-lv",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇱🇾",
      identifier: "flag-ly",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇦",
      identifier: "flag-ma",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇨",
      identifier: "flag-mc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇩",
      identifier: "flag-md",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇪",
      identifier: "flag-me",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇫",
      identifier: "flag-mf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇬",
      identifier: "flag-mg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇭",
      identifier: "flag-mh",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇰",
      identifier: "flag-mk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇱",
      identifier: "flag-ml",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇲",
      identifier: "flag-mm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇳",
      identifier: "flag-mn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇴",
      identifier: "flag-mo",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇵",
      identifier: "flag-mp",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇶",
      identifier: "flag-mq",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇷",
      identifier: "flag-mr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇸",
      identifier: "flag-ms",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇹",
      identifier: "flag-mt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇺",
      identifier: "flag-mu",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇻",
      identifier: "flag-mv",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇼",
      identifier: "flag-mw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇽",
      identifier: "flag-mx",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇾",
      identifier: "flag-my",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇲🇿",
      identifier: "flag-mz",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇦",
      identifier: "flag-na",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇨",
      identifier: "flag-nc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇪",
      identifier: "flag-ne",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇫",
      identifier: "flag-nf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇬",
      identifier: "flag-ng",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇮",
      identifier: "flag-ni",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇱",
      identifier: "flag-nl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇴",
      identifier: "flag-no",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇵",
      identifier: "flag-np",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇷",
      identifier: "flag-nr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇺",
      identifier: "flag-nu",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇳🇿",
      identifier: "flag-nz",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇴🇲",
      identifier: "flag-om",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇦",
      identifier: "flag-pa",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇪",
      identifier: "flag-pe",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇫",
      identifier: "flag-pf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇬",
      identifier: "flag-pg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇭",
      identifier: "flag-ph",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇰",
      identifier: "flag-pk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇱",
      identifier: "flag-pl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇲",
      identifier: "flag-pm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇳",
      identifier: "flag-pn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇷",
      identifier: "flag-pr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇸",
      identifier: "flag-ps",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇹",
      identifier: "flag-pt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇼",
      identifier: "flag-pw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇵🇾",
      identifier: "flag-py",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇶🇦",
      identifier: "flag-qa",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇷🇪",
      identifier: "flag-re",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇷🇴",
      identifier: "flag-ro",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇷🇸",
      identifier: "flag-rs",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇷🇺",
      identifier: "ru",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇷🇼",
      identifier: "flag-rw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇦",
      identifier: "flag-sa",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇧",
      identifier: "flag-sb",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇨",
      identifier: "flag-sc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇩",
      identifier: "flag-sd",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇪",
      identifier: "flag-se",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇬",
      identifier: "flag-sg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇭",
      identifier: "flag-sh",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇮",
      identifier: "flag-si",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇯",
      identifier: "flag-sj",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇰",
      identifier: "flag-sk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇱",
      identifier: "flag-sl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇲",
      identifier: "flag-sm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇳",
      identifier: "flag-sn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇴",
      identifier: "flag-so",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇷",
      identifier: "flag-sr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇸",
      identifier: "flag-ss",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇹",
      identifier: "flag-st",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇻",
      identifier: "flag-sv",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇽",
      identifier: "flag-sx",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇾",
      identifier: "flag-sy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇸🇿",
      identifier: "flag-sz",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇦",
      identifier: "flag-ta",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇨",
      identifier: "flag-tc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇩",
      identifier: "flag-td",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇫",
      identifier: "flag-tf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇬",
      identifier: "flag-tg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇭",
      identifier: "flag-th",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇯",
      identifier: "flag-tj",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇰",
      identifier: "flag-tk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇱",
      identifier: "flag-tl",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇲",
      identifier: "flag-tm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇳",
      identifier: "flag-tn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇴",
      identifier: "flag-to",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇷",
      identifier: "flag-tr",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇹",
      identifier: "flag-tt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇻",
      identifier: "flag-tv",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇼",
      identifier: "flag-tw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇹🇿",
      identifier: "flag-tz",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇺🇦",
      identifier: "flag-ua",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇺🇬",
      identifier: "flag-ug",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇺🇲",
      identifier: "flag-um",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇺🇳",
      identifier: "flag-un",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇺🇸",
      identifier: "us",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇺🇾",
      identifier: "flag-uy",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇺🇿",
      identifier: "flag-uz",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇻🇦",
      identifier: "flag-va",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇻🇨",
      identifier: "flag-vc",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇻🇪",
      identifier: "flag-ve",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇻🇬",
      identifier: "flag-vg",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇻🇮",
      identifier: "flag-vi",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇻🇳",
      identifier: "flag-vn",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇻🇺",
      identifier: "flag-vu",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇼🇫",
      identifier: "flag-wf",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇼🇸",
      identifier: "flag-ws",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇽🇰",
      identifier: "flag-xk",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇾🇪",
      identifier: "flag-ye",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇾🇹",
      identifier: "flag-yt",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇿🇦",
      identifier: "flag-za",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇿🇲",
      identifier: "flag-zm",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🇿🇼",
      identifier: "flag-zw",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
      identifier: "flag-england",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
      identifier: "flag-scotland",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
      identifier: "flag-wales",
      isEmojiBase: !0,
      supportedTwemoji: null
    },
    {
      unicode: "🏻",
      identifier: "light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏼",
      identifier: "medium_light_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏽",
      identifier: "medium_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏾",
      identifier: "medium_dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    },
    {
      unicode: "🏿",
      identifier: "dark_skin_tone",
      isEmojiBase: !1,
      supportedTwemoji: null
    }
  ]
];
export {
  e as default
};
